import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Animacao } from '../../core/tools/animacao';
import { ToastrService } from 'ngx-toastr';

import { ChartType, ChartData } from 'chart.js';
import pluginDataLabels from 'chartjs-plugin-datalabels';

/* Services */

import { CallCenterService } from '../../core/services/call-center/call-center.service';
import { CallCenterDiscadorService } from '../../core/services/call-center-discador/call-center-discador.service';
import { CentralAtendimentoService } from '../../core/services/central-atendimento/central-atendimento.service';
import { ClienteService } from '../../core/services/clientes/cliente.service';
import { ExcelService } from '../../core/tools/excel.service';
import { PedidoTotalizadorService } from '../../core/services/pedidos/pedido-totalizador.service';
import { ProdutoService } from '../../core/services/produtos/produto.service';
import { VisitaService } from '../../core/services/visitas/visita.service';

/* Models */

import { CallCenterConfiguracao } from '../../core/models/call-center/call-center-configuracao';
import { CallCenterCrmBoard, CallCenterCrmEtapa, CallCenterCrmLigacao } from '../../core/models/call-center/call-center-crm-ligacao';
import { CallCenterLigacaoAnalitica } from '../../core/models/call-center/call-center-ligacao-analitica';
import { CallCenterLigacaoSintetica } from '../../core/models/call-center/call-center-ligacao-sintetica';
import { CallCenterOportunidade } from '../../core/models/call-center/call-center-oportunidade';
import { CallCenterOportunidadeClassificacao } from '../../core/models/call-center/call-center-oportunidade-classificacao';
import { CallCenterOportunidadeFiltrar } from '../../core/models/call-center/call-center-oportunidade-filtrar';
import { CallCenterRota } from '../../core/models/call-center/call-center-rota';
import { CallCenterRotaCliente } from '../../core/models/call-center/call-center-rota-cliente';
import { CallCenterRotaVendedor } from '../../core/models/call-center/call-center-rota-vendedor';
import { ClienteTag } from '../../core/models/clientes/cliente-tag';
import { Estatistica } from '../../core/models/pedidos/estatistica';
import { Produto } from '../../core/models/produtos/produto';
import { Visita } from '../../core/models/visitas/visita';

@Component({
    selector: 'app-call-center',
    templateUrl: './call-center.component.html',
    styleUrls: ['./call-center.component.css'],
    preserveWhitespaces: false,
    animations: [Animacao],
    standalone: false
})

export class CallCenterComponent implements OnInit {
  /* Carregamento */

  carregando: boolean = false;

  /* Abas */

  tabSelecionada: string = "crm-ligacoes";

  /* Dados */

    /* Filtro (Produtos) */

    produtoEmBranco: boolean = false;
    produtoInvalido: boolean = false;

    produtos: Produto[] = [];
    produtosOriginal: Produto[] = [];

    produtoSelecionado: Produto = null;

  /* Filtros */

  formFiltro: UntypedFormGroup;

  filtroOpcoes: any[] = [
    { texto: "Cidade", valor: "0" },
    { texto: "Classificação", valor: "1" },
    { texto: "Cliente", valor: "2" },
    { texto: "CNPJ/CPF", valor: "3" },
    { texto: "Código", valor: "4" },
    { texto: "Dias sem Compra", valor: "5" },
    { texto: "Dias sem Visita", valor: "6" },
    { texto: "Produto", valor: "7" },
    { texto: "Realizado Ano", valor: "8" },
    { texto: "Realizado Mês", valor: "9" },
    { texto: "Segmento", valor: "10" },
    { texto: "Tags", valor: "11" }
  ];

  enviado: boolean = false;
  filtrado: boolean = false;
  filtradoVendedor: boolean = false;

  /* Filtro (Produtos) */

  formFiltroProduto: UntypedFormGroup;

  filtroProdutos: any[] = [
    { texto: "Código", valor: "0" },
    { texto: "Descrição", valor: "1" },
    { texto: "Marca", valor: "2" }
  ];

  enviadoProduto: boolean = false;

  filtrandoProduto: boolean = false;

  /* Tags */

  tagFiltro: any = [];
  tagFiltroErro: boolean = false;
  tagFiltroOpcoes: any = [];

  /* Ordernar (Ligações) */

  ordernarLigacoesOpcoes: any[] = [];

  ordernarLigacoesOpcoesOrdem: any[] = [
    { texto: "Crescente", valor: "0" },
    { texto: "Decrescente", valor: "1" }
  ];

  ordernarLigacoesSelecionado: string = "relationship";
  ordernarLigacoesOrdemSelecionado: string = "0";

  /* Ordernar (Oportunidades) */

  ordernarOportunidadesOpcoes: any[] = [];

  ordernarOportunidadesOpcoesOrdem: any[] = [
    { texto: "Crescente", valor: "0" },
    { texto: "Decrescente", valor: "1" }
  ];

  ordernarOportunidadesSelecionado: string = "name";
  ordernarOportunidadesOrdemSelecionado: string = "0";

  /* Gráfico de Status de Chamadas */

  pieChartOptions: any = {
    animation: {
      duration: 0
    },
    responsive: true,
    plugins: {
      legend: {
        position: "right",
        labels: {
          color: "rgba(0, 0, 0, 1)"
        }
      },
      datalabels: {
        color: "rgba(0, 0, 0, 1)",
        font: {
          weight: "bold"
        },
        formatter: (value) => {
          return value + "%";
        }
      }
    }
  };

  pieChartType: ChartType = "pie";
  pieChartPlugins = [pluginDataLabels];
  pieChartData: ChartData<'pie'> = { labels: [], datasets: [{ data: [], backgroundColor: [] }] };

  /* Call Center (Configurações) */

  callCenterConfiguracao: CallCenterConfiguracao = null;

  /* Call Center (Ligações) */

    /* Ligações Analíticas */

    ligacoesAnaliticas: CallCenterLigacaoAnalitica[] = [];
    ligacoesAnaliticasOriginal: CallCenterLigacaoAnalitica[] = [];

    ligacaoAnaliticaMensagem: string = "";

    /* CRM Ligações */

    crmBoard: CallCenterCrmBoard = { etapas: [], ligacoes: [] };
    crmEtapas: CallCenterCrmEtapa[] = [];
    crmLigacoes: CallCenterCrmLigacao[] = [];
    crmLigacoesOriginal: CallCenterCrmLigacao[] = [];
    crmLigacoesHoje: CallCenterLigacaoAnalitica[] = [];
    crmLigacoesLote: number = 20;
    crmLigacoesVisiveisPorEtapa: { [key: number]: number } = {};
    crmBoardArrastando: boolean = false;
    crmBoardArrasteInicioX: number = 0;
    crmBoardScrollInicio: number = 0;
    crmFiltroDataLigacao: string = "";
    crmFiltroCliente: string = "";
    crmFiltroVendedor: string = "";
    crmFiltroVendInterna: string = "";
    crmFiltroCidade: string = "";
    crmFiltroTemMensagem: string = "";
    crmDatasLigacaoFiltro: string[] = [];
    crmClientesFiltro: any[] = [];
    crmVendedoresFiltro: any[] = [];
    crmVendedorasInternasFiltro: string[] = [];
    crmCidadesFiltro: string[] = [];
    crmImportacaoArquivo: File = null;
    crmImportacaoLinhas: any[] = [];
    crmImportacaoErros: any[] = [];
    crmImportacaoAtualizarAoFechar: boolean = false;
    crmImportando: boolean = false;
    crmCalendarioDataReferencia: Date = new Date();
    crmCalendarioDias: any[] = [];
    crmCalendarioLigacaoSelecionada: CallCenterCrmLigacao = null;
    crmCalendarioLigacoesSelecionadasIds: number[] = [];
    crmCalendarioNovaData: string = "";
    crmCalendarioSemana: string[] = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];
    crmCalendarioModo: string = "FUTURAS";
    crmCalendarioFiltroVendInterna: string = "";
    crmInativacaoMassaVendInterna: string = "";
  
    /* Ligações Sintéticas */

    ligacoesSinteticas: CallCenterLigacaoSintetica[] = [];

  /* Call Center (Oportunidades) */

  oportunidades: CallCenterOportunidade[] = [];

  /* Call Center (Rotas) */

  rotasVendedores: CallCenterRotaVendedor[] = [];
  rotas: CallCenterRota[] = [];
  rotasClientes: CallCenterRotaCliente[] = [];

  rotaSellerSelecionado: number = null;
  rotaSelecionada: number = null;
  qtdeRotasLigacaoOk: number = 0;

  /* Classificações */

  filtroClassificacoes: CallCenterOportunidadeClassificacao[] = [];

  /* Visitas */

  visitas: Visita[] = [];

  /* Acompanhamento */

  /* Análise Sintética */

  valorVendasDia: number = 0;
  porcentagemVendasDia: number = 0;
  valorVendasMes: number = 0;

  /* Atenção/Ligações */

  qtdeLigacoes: number = 0;
  qtdeRealizado: number = 0;
  porcentagemQtdeRealizado: number = 0;
  valorMetaDia: number = 0;

  /* Oportunidades */

  qtdeClientes: number = 0;
  qtdeClientesPadrao: number = 0;
  qtdeClientesAdicionais: number = 0;
  valorMetaMes: number = 0;

  /* Estatística (Status do Pedido) */

  estatisticasClientes: Estatistica[] = [];

  /* Tags (Clientes) */

  tagCliente: any = [];
  tagClienteOpcoes: any = [];

  tagClienteIdSelecionado: number = 0;
  tagClienteNomeSelecionado: string = "";

  /* Modal */

  @ViewChild("geracaoLigacoesDiaResumo") geracaoLigacoesDiaResumo: ElementRef;

  geracaoLigacoesDiaResumoDados: any = null;

  /* Storage */

  modelo_tela_ligacoes: number = parseInt(localStorage.getItem("modelo_tela_ligacoes"));
  seller_id: number = parseInt(localStorage.getItem("id"));
  usa_pabx: boolean = (localStorage.getItem("usa_pabx") == "true");
  podeImportarCrmLigacoes: boolean = (localStorage.getItem("is_master") == "true" || localStorage.getItem("is_diretor") == "true");
  podeVisualizarCrmCalendarioGeral: boolean = (localStorage.getItem("is_master") == "true" || localStorage.getItem("is_diretor") == "true");

  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private formBuilder: UntypedFormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private callCenterService: CallCenterService,
    private callCenterDiscadorService: CallCenterDiscadorService,
    private centralAtendimentoService: CentralAtendimentoService,
    private clienteService: ClienteService,
    private excelService: ExcelService,
    private pedidoTotalizadorService: PedidoTotalizadorService,
    private produtoService: ProdutoService,
    private visitaService: VisitaService
  ) { }

  ngAfterViewInit() {
    this.centralAtendimentoService.maximizarEmitter.emit(true);

    setTimeout(() => {
      this.abrirResumoGeracaoLigacoesDia();
    }, 400);
  }

  abrirResumoGeracaoLigacoesDia() {
    let resumo = localStorage.getItem("call_center_geracao_ligacoes_dia_resumo");

    if (resumo == null || resumo == "") {
      return;
    }

    localStorage.removeItem("call_center_geracao_ligacoes_dia_resumo");

    try {
      this.geracaoLigacoesDiaResumoDados = JSON.parse(resumo);
    } catch {
      this.geracaoLigacoesDiaResumoDados = null;
    }

    if (this.geracaoLigacoesDiaResumoDados == null) {
      return;
    }

    this.modalService.open(this.geracaoLigacoesDiaResumo, { size: "lg", backdrop: "static" });
  }

  ngOnDestroy() {
    this.modalService.dismissAll();

    if (this.router.routerState.snapshot.url.indexOf("call-center-ligacao") !== 1 && this.router.routerState.snapshot.url.indexOf("call-center-nova-ligacao") !== 1) {
      this.apagarFiltroArmazenado();
    }
  }

  iniciarFormulario() {
    this.formFiltro = this.formBuilder.group({
      filtro: ["2"],
      cidade: ["", [Validators.required, Validators.minLength(3)]],
      classificacao: ["", Validators.required],
      cliente: ["", [Validators.required, Validators.minLength(3)]],
      cnpj_cpf: ["", Validators.required],
      codigo: ["", Validators.required],
      nro_inicial_sem_compra: ["", Validators.required],
      nro_final_sem_compra: [""],
      nro_inicial_sem_visita: ["", Validators.required],
      nro_final_sem_visita: [""],
      valor_inicial_realizado_ano: ["", Validators.required],
      valor_final_realizado_ano: [""],
      valor_inicial_realizado_mes: ["", Validators.required],
      valor_final_realizado_mes: [""],
      segmento: ["", Validators.required],
      vendedor: [""]
    });
  }

  ngOnInit() {
    /* Filtros */

    this.iniciarFormulario();
    this.organizarFiltro();

    /* Filtro (Produtos) */

    this.formFiltroProduto = this.formBuilder.group({
      filtro: ["1"],
      codigo: ["", Validators.required],
      descricao: ["", Validators.required],
      marca: ["", Validators.required]
    });

    this.organizarFiltroProduto();

    /* Ordernar (Ligações) */

    if (this.modelo_tela_ligacoes == 0) {
      /* Modelo 1 */

      this.ordernarLigacoesOpcoes = [
        { texto: "Tipo (Ligação)", valor: "tipo" },
        { texto: "Status (Ligação)", valor: "status_name" },
        { texto: "Hora (Ligação)", valor: "data_ligacao" },
        { texto: "Agendamento", valor: "call_center_prox_agenda" },
        { texto: "Cliente", valor: "name" },
        { texto: "Cidade", valor: "cidade" },
        { texto: "Estado", valor: "estado" },
        { texto: "Vendedor(a)", valor: "fullname" },
        { texto: "Ult. Visita", valor: "ult_visit" },
        { texto: "Ult. Visita Dias", valor: "qtdediasultvis" },
        { texto: "Ult. Compra", valor: "ult_compra" },
        { texto: "Ult. Compra Dias", valor: "qtdediasultcompra" },
        { texto: "Objetivo Mês", valor: "objetivo_venda" },
        { texto: "Realizado Mês", valor: "realizado_venda" },
        { texto: "Falta Vender Mês", valor: "falta_vender" },
        { texto: "Status (Cliente)", valor: "relationship" },
        { texto: "Atenção", valor: "flag_atencao" }
      ];
    } else if (this.modelo_tela_ligacoes == 1) {
      /* Modelo 2 */

      this.ordernarLigacoesOpcoes = [
        { texto: "Tipo (Ligação)", valor: "tipo" },
        { texto: "Status (Ligação)", valor: "status_name" },
        { texto: "Hora (Ligação)", valor: "data_ligacao" },
        { texto: "Agendamento", valor: "call_center_prox_agenda" },
        { texto: "Cliente", valor: "name" },
        { texto: "Estado", valor: "estado" },
        { texto: "CNPJ/CPF", valor: "client_document" },
        { texto: "PV", valor: "pv" },
        { texto: "Segmento", valor: "segment" },
        { texto: "Zona", valor: "zona_vendas" },
        { texto: "Ult. Visita", valor: "ult_visit" },
        { texto: "Ult. Visita Dias", valor: "qtdediasultvis" },
        { texto: "Ult. Compra", valor: "ult_compra" },
        { texto: "Ult. Compra Dias", valor: "qtdediasultcompra" },
        { texto: "Potêncial Ano", valor: "potencial_ano" },
        { texto: "Realizado Ano", valor: "realizado_ano" },
        { texto: "% Ano", valor: "porcentagem_ano" },
        { texto: "Falta Ano", valor: "falta_ano" },
        { texto: "Objetivo Mês", valor: "objetivo_venda" },
        { texto: "Realizado Mês", valor: "realizado_venda" },
        { texto: "% Mês", valor: "porcentagem_venda" },
        { texto: "Mês Anterior", valor: "realizado_venda_mesanterior" },
        { texto: "Status (Cliente)", valor: "relationship" },
        { texto: "Atenção", valor: "flag_atencao" }
      ];
    }

    /* Ordernar (Oportunidades) */

    if (this.modelo_tela_ligacoes == 0) {
      /* Modelo 1 */

      this.ordernarOportunidadesOpcoes = [
        { texto: "Status", valor: "relationship" },
        { texto: "Agendamento", valor: "call_center_prox_agenda" },
        { texto: "Cliente", valor: "name" },
        { texto: "Cidade", valor: "cidade" },
        { texto: "Estado", valor: "estado" },
        { texto: "CNPJ/CPF", valor: "client_document" },
        { texto: "Segmento", valor: "segment" },
        { texto: "Vendedor(a)", valor: "fullname" },
        { texto: "Ult. Visita", valor: "ultvisita" },
        { texto: "Ult. Visita Dias", valor: "qtdediasultvisita" },
        { texto: "Ult. Compra", valor: "ultcomp" },
        { texto: "Ult. Compra Dias", valor: "qtdediasultcomp" },
        { texto: "Objetivo", valor: "objetivo_de_venda" },
        { texto: "Realizado", valor: "order_total" },
        { texto: "Falta Vender", valor: "falta_vender" },
        { texto: "Atenção", valor: "atencao" }
      ];
    } else if (this.modelo_tela_ligacoes == 1) {
      /* Modelo 2 */

      this.ordernarOportunidadesOpcoes = [
        { texto: "Status", valor: "relationship" },
        { texto: "Agendamento", valor: "call_center_prox_agenda" },
        { texto: "Cliente", valor: "name" },
        { texto: "Estado", valor: "estado" },
        { texto: "CNPJ/CPF", valor: "client_document" },
        { texto: "PV", valor: "pv" },
        { texto: "Segmento", valor: "segment" },
        { texto: "Zona", valor: "zona_vendas" },
        { texto: "Ult. Visita", valor: "ultvisita" },
        { texto: "Ult. Visita Dias", valor: "qtdediasultvisita" },
        { texto: "Ult. Compra", valor: "ultcomp" },
        { texto: "Ult. Compra Dias", valor: "qtdediasultcomp" },
        { texto: "Potêncial Ano", valor: "potencial_ano" },
        { texto: "Realizado Ano", valor: "realizado_ano" },
        { texto: "% Ano", valor: "porcentagem_ano" },
        { texto: "Falta Ano", valor: "falta_ano" },
        { texto: "Objetivo Mês", valor: "objetivo_de_venda" },
        { texto: "Realizado Mês", valor: "realizado_venda" },
        { texto: "% Mês", valor: "porcentagem_venda" },
        { texto: "Mês Anterior", valor: "realizado_venda_mesanterior" },
        { texto: "Atenção", valor: "atencao" }
      ];
    }

    this.verificarFiltro().then((filtroRestaurado) => {
      if (!filtroRestaurado) {
        this.carregarCrmLigacoes();
        return;
      }

      if (this.tabSelecionada == "crm-ligacoes") {
        this.carregarCrmLigacoes();
      } else if (this.tabSelecionada == "rotas") {
        this.carregarRotasVendedores();
      }
    });
  }

  get ff() {
    return this.formFiltro.controls;
  }

  get fp() {
    return this.formFiltroProduto.controls;
  }

  /* Abas */

  alterarAbas(evento: any) {
    /* Ligações Analíticas */

    this.ligacoesAnaliticas = [];
    this.ligacoesAnaliticasOriginal = [];

    /* Call Center (Oportunidades) */

    this.oportunidades = [];

    /* Call Center (Rotas) */

    this.rotasClientes = [];

    /* Abas */

    this.tabSelecionada = evento.nextId;

    this.alterarFiltro("2");
    this.apagarFiltroArmazenado();

    if (evento.nextId == "atencao" || evento.nextId == "ligacoes") {
      this.carregarDadosLigacoes();
    } else if (evento.nextId == "crm-ligacoes") {
      let discador_ativo: boolean = (localStorage.getItem("discador_ativo") == "true");

      if (discador_ativo) {
        evento.preventDefault();

        return;
      }

      this.tabSelecionada = evento.nextId;
      this.carregarCrmLigacoes();
    } else if (evento.nextId == "oportunidades") {
      /* Storage */

      let discador_ativo: boolean = (localStorage.getItem("discador_ativo") == "true");

      if (discador_ativo) {
        evento.preventDefault();

        return;
      }

      this.tabSelecionada = evento.nextId;
    } else if (evento.nextId == "rotas") {
      /* Storage */

      let discador_ativo: boolean = (localStorage.getItem("discador_ativo") == "true");

      if (discador_ativo) {
        evento.preventDefault();

        return;
      }

      this.tabSelecionada = evento.nextId;
      this.carregarRotasVendedores();
    }
  }

  /* Ações */

  ajustarLigacoes(parcial: boolean) {
    this.ligacoesAnaliticas.forEach((item) => {
      if ((item.objetivo_venda - item.realizado_venda) < 0) {
        item.falta_vender = 0;
      } else {
        item.falta_vender = item.objetivo_venda - item.realizado_venda;
      }

      item.exibir = true;
    });

    if (this.modelo_tela_ligacoes == 1) {
      /* Modelo 2 */

      this.ligacoesAnaliticas.sort((a, b) => {
        const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

        return compare(a["ult_visit"], b["ult_visit"]);
      });

      this.ordernarLigacoesSelecionado = "ult_visit";
    }

    if (!parcial) {
      this.ligacoesAnaliticasOriginal = JSON.parse(JSON.stringify(this.ligacoesAnaliticas));
    }
  }

  alterarLigacao(ligacao_selecionada: number) {
    this.continuarNovaLigacao(null, ligacao_selecionada);
  }

  atualizar() {
    if (this.tabSelecionada == "rotas") {
      this.carregarClientesDaRota();
    } else if (this.tabSelecionada == "crm-ligacoes") {
      this.carregarCrmLigacoes();
    } else {
      this.carregarDadosLigacoes();
    }
  }

  novaLigacao(id_cliente: any) {
    this.armazenarFiltro();

    this.continuarNovaLigacao(id_cliente, null);
  }

  novaLigacaoRota(cliente: CallCenterRotaCliente) {
    this.novaLigacao(cliente.codigo_no_erp_do_cliente);
  }

  carregarRotasVendedores() {
    this.rotasVendedores = [];
    this.rotas = [];
    this.rotasClientes = [];
    this.qtdeRotasLigacaoOk = 0;
    this.rotaSellerSelecionado = null;
    this.rotaSelecionada = null;

    this.callCenterService.getRotaVendedorByUsuario().subscribe(
      rotasVendedores => {
        this.rotasVendedores = rotasVendedores;

        if (this.rotasVendedores.length == 1) {
          this.rotaSellerSelecionado = this.rotasVendedores[0].id;
          this.carregarRotasPorVendedor();
        }
      }
    );
  }

  carregarRotasPorVendedor() {
    this.rotas = [];
    this.rotasClientes = [];
    this.qtdeRotasLigacaoOk = 0;
    this.rotaSelecionada = null;

    if (this.rotaSellerSelecionado == null) {
      return;
    }

    this.callCenterService.getRotaByVendedor(this.rotaSellerSelecionado).subscribe(
      rotas => {
        this.rotas = rotas;

        if (this.rotas.length == 1) {
          this.rotaSelecionada = this.rotas[0].id;
          this.carregarClientesDaRota();
        }
      }
    );
  }

  carregarClientesDaRota() {
    this.rotasClientes = [];
    this.qtdeRotasLigacaoOk = 0;

    if (this.rotaSellerSelecionado == null || this.rotaSelecionada == null) {
      return;
    }

    this.callCenterService.getRotaClienteByRota(this.rotaSellerSelecionado, this.rotaSelecionada).subscribe(
      rotasClientes => {
        this.rotasClientes = rotasClientes;
        this.qtdeRotasLigacaoOk = this.rotasClientes.filter(cliente => cliente.ligacao_ok).length;
      }
    );
  }

  carregarCrmLigacoes() {
    this.carregando = true;
    this.crmBoard = { etapas: [], ligacoes: [] };
    this.crmEtapas = [];
    this.crmLigacoes = [];
    this.crmLigacoesOriginal = [];
    this.crmLigacoesHoje = [];
    this.crmLigacoesVisiveisPorEtapa = {};

    this.callCenterService.getCrmLigacoesBoard().subscribe(
      board => this.crmBoard = board,
      error => { console.log("Erro: " + error) },
      () => {
        this.crmEtapas = this.crmBoard.etapas || [];
        this.crmLigacoesOriginal = this.crmBoard.ligacoes || [];
        this.montarFiltrosCrmLigacoes();
        this.aplicarFiltrosCrmLigacoes();

        this.carregando = false;
      }
    );
  }

  private recarregarCrmLigacoesCalendario() {
    this.carregando = true;

    this.callCenterService.getCrmLigacoesBoard().subscribe(
      board => this.crmBoard = board,
      error => { console.log("Erro: " + error) },
      () => {
        this.crmEtapas = this.crmBoard.etapas || [];
        this.crmLigacoesOriginal = this.crmBoard.ligacoes || [];
        this.montarFiltrosCrmLigacoes();
        this.aplicarFiltrosCrmLigacoes();
        this.montarCrmCalendario();
        this.carregando = false;
      }
    );
  }

  montarFiltrosCrmLigacoes() {
    let datas = new Set<string>();
    let cidades = new Set<string>();
    let clientes = new Map<number, string>();
    let vendedores = new Map<number, string>();
    let vendedorasInternas = new Set<string>();

    this.crmLigacoesOriginal.forEach(ligacao => {
      let data = this.datePipe.transform(ligacao.data_ligacao, "yyyy-MM-dd");

      if (data != null && data != "") {
        datas.add(data);
      }

      if (ligacao.cidade != null && ligacao.cidade.trim() != "") {
        cidades.add(ligacao.cidade.trim());
      }

      if (ligacao.client_id != null && ligacao.client_id > 0) {
        clientes.set(ligacao.client_id, ligacao.name || ligacao.client_id.toString());
      }

      if (ligacao.seller_id != null && ligacao.seller_id > 0) {
        vendedores.set(ligacao.seller_id, ligacao.fullname || ligacao.seller_id.toString());
      }

      if (ligacao.vendinterna != null && ligacao.vendinterna.trim() != "") {
        vendedorasInternas.add(ligacao.vendinterna.trim());
      }
    });

    this.crmDatasLigacaoFiltro = Array.from(datas).sort((a, b) => b.localeCompare(a));
    this.crmCidadesFiltro = Array.from(cidades).sort((a, b) => a.localeCompare(b));
    this.crmClientesFiltro = Array.from(clientes.entries())
      .map(([id, nome]) => ({ id, nome }))
      .sort((a, b) => a.nome.localeCompare(b.nome));
    this.crmVendedoresFiltro = Array.from(vendedores.entries())
      .map(([id, nome]) => ({ id, nome }))
      .sort((a, b) => a.nome.localeCompare(b.nome));
    this.crmVendedorasInternasFiltro = Array.from(vendedorasInternas).sort((a, b) => a.localeCompare(b));
  }

  aplicarFiltrosCrmLigacoes() {
    let vendedoresDisponiveis = this.crmVendedoresFiltroDinamico();
    let cidadesDisponiveis = this.crmCidadesFiltroDinamico();

    if (this.crmFiltroVendedor != "" && !vendedoresDisponiveis.some(vendedor => vendedor.id.toString() == this.crmFiltroVendedor)) {
      this.crmFiltroVendedor = "";
    }

    if (this.crmFiltroCidade != "" && !cidadesDisponiveis.some(cidade => cidade == this.crmFiltroCidade)) {
      this.crmFiltroCidade = "";
    }

    this.crmLigacoes = this.crmLigacoesOriginal.filter(ligacao => {
      return this.crmLigacaoAtendeFiltros(ligacao);
    });

    this.resetarLotesCrmLigacoes();

    this.crmLigacoesHoje = this.crmLigacoes
      .filter(ligacao => ligacao.etapa_codigo == "HOJE" && this.crmLigacaoDisponivelParaDiscador(ligacao))
      .map(ligacao => {
        let ligacaoAnalitica = Object.assign(new CallCenterLigacaoAnalitica(), ligacao);

        ligacaoAnalitica.id = ligacao.id;
        ligacaoAnalitica.client_id = ligacao.client_id;
        ligacaoAnalitica.id_status = this.crmIdStatusDiscador(ligacao);

        return ligacaoAnalitica;
      });
  }

  crmVendedoresFiltroDinamico() {
    let vendedores = new Map<number, string>();

    this.crmLigacoesOriginal
      .filter(ligacao => this.crmLigacaoAtendeFiltros(ligacao, true))
      .forEach(ligacao => {
        if (ligacao.seller_id != null && ligacao.seller_id > 0) {
          vendedores.set(ligacao.seller_id, ligacao.fullname || ligacao.seller_id.toString());
        }
      });

    return Array.from(vendedores.entries())
      .map(([id, nome]) => ({ id, nome }))
      .sort((a, b) => a.nome.localeCompare(b.nome));
  }

  crmCidadesFiltroDinamico() {
    let cidades = new Set<string>();

    this.crmLigacoesOriginal
      .filter(ligacao => this.crmLigacaoAtendeFiltros(ligacao, false, true))
      .forEach(ligacao => {
        if (ligacao.cidade != null && ligacao.cidade.trim() != "") {
          cidades.add(ligacao.cidade.trim());
        }
      });

    return Array.from(cidades).sort((a, b) => a.localeCompare(b));
  }

  private crmLigacaoAtendeFiltros(ligacao: CallCenterCrmLigacao, ignorarVendedor: boolean = false, ignorarCidade: boolean = false) {
    let data = this.datePipe.transform(ligacao.data_ligacao, "yyyy-MM-dd") || "";
    let cliente = (ligacao.name || "").toLowerCase();
    let clienteFiltro = (this.crmFiltroCliente || "").toLowerCase().trim();
    let vendedor = ligacao.seller_id == null ? "" : ligacao.seller_id.toString();
    let vendInterna = ligacao.vendinterna || "";
    let cidade = ligacao.cidade || "";
    let temMensagem = ligacao.mensagem != null;

    return (this.crmFiltroDataLigacao == "" || data == this.crmFiltroDataLigacao)
      && (clienteFiltro == "" || cliente.indexOf(clienteFiltro) > -1)
      && (ignorarVendedor || this.crmFiltroVendedor == "" || vendedor == this.crmFiltroVendedor)
      && (this.crmFiltroVendInterna == "" || vendInterna == this.crmFiltroVendInterna)
      && (ignorarCidade || this.crmFiltroCidade == "" || cidade == this.crmFiltroCidade)
      && (this.crmFiltroTemMensagem == "" || (this.crmFiltroTemMensagem == "S" && temMensagem) || (this.crmFiltroTemMensagem == "N" && !temMensagem));
  }

  private crmLigacaoDisponivelParaDiscador(ligacao: CallCenterCrmLigacao) {
    let status = this.crmNormalizarTexto(ligacao.status_name);

    return ligacao.id_status == 1
      || ligacao.id_status == 6
      || status == "a ligar"
      || status == "agendada";
  }

  private crmIdStatusDiscador(ligacao: CallCenterCrmLigacao) {
    let status = this.crmNormalizarTexto(ligacao.status_name);

    if (ligacao.id_status == 1 || status == "a ligar") {
      return 1;
    }

    if (ligacao.id_status == 6 || status == "agendada") {
      return 6;
    }

    return ligacao.id_status;
  }

  private crmNormalizarTexto(valor: string) {
    return (valor || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  }

  limparFiltrosCrmLigacoes() {
    this.crmFiltroDataLigacao = "";
    this.crmFiltroCliente = "";
    this.crmFiltroVendedor = "";
    this.crmFiltroVendInterna = "";
    this.crmFiltroCidade = "";
    this.crmFiltroTemMensagem = "";
    this.aplicarFiltrosCrmLigacoes();
  }

  modalImportarCrmLigacoes(content: any) {
    if (!this.podeImportarCrmLigacoes) {
      return;
    }

    this.crmImportacaoArquivo = null;
    this.crmImportacaoLinhas = [];
    this.crmImportacaoErros = [];
    this.crmImportacaoAtualizarAoFechar = false;
    this.crmImportando = false;

    this.modalService.open(content, { size: "lg", backdrop: "static" });
  }

  baixarModeloCrmLigacoes() {
    this.excelService.exportAsExcelFile([
      {
        codclierp: "12345",
        data_ligacao: this.datePipe.transform(new Date(), "dd/MM/yyyy"),
        mensagem: "Mensagem da ligacao"
      }
    ], "modelo_importacao_crm_ligacoes");
  }

  selecionarArquivoCrmLigacoes(event: any) {
    this.crmImportacaoArquivo = null;
    this.crmImportacaoLinhas = [];
    this.crmImportacaoErros = [];

    let arquivo = event.target.files != null && event.target.files.length > 0 ? event.target.files[0] : null;

    if (arquivo == null) {
      return;
    }

    let nomeArquivo = (arquivo.name || "").toLowerCase();

    if (!nomeArquivo.endsWith(".xlsx") && !nomeArquivo.endsWith(".xls")) {
      this.toastr.warning("", "Selecione uma planilha do Excel.");
      event.target.value = "";
      return;
    }

    this.crmImportacaoArquivo = arquivo;

    let reader = new FileReader();
    reader.onload = () => {
      let linhasExcel = this.excelService.importExcelBinaryToJson(reader.result as string);
      let linhas: any[] = [];
      let erros: any[] = [];

      linhasExcel.forEach((linhaExcel: any, index: number) => {
        let linhaPlanilha = index + 2;
        let codclierp = (this.valorColunaImportacaoCrm(linhaExcel, "codclierp") || "").toString().trim();
        let dataLigacao = this.normalizarDataImportacaoCrm(this.valorColunaImportacaoCrm(linhaExcel, "data_ligacao"));
        let mensagem = (this.valorColunaImportacaoCrm(linhaExcel, "mensagem") || "").toString().trim();

        if (codclierp == "") {
          erros.push({ linha: linhaPlanilha, codclierp: codclierp, data_ligacao: this.formatarDataTelaImportacaoCrm(dataLigacao), cliente: "", erro: "codclierp nao informado." });
        }

        if (dataLigacao == "") {
          erros.push({ linha: linhaPlanilha, codclierp: codclierp, data_ligacao: "", cliente: "", erro: "data_ligacao nao informada ou invalida." });
        }

        linhas.push({
          linha: linhaPlanilha,
          codclierp: codclierp,
          data_ligacao: dataLigacao,
          mensagem: mensagem
        });
      });

      if (linhasExcel.length == 0) {
        erros.push({ linha: 0, codclierp: "", data_ligacao: "", cliente: "", erro: "Planilha sem registros para importar." });
      }

      this.crmImportacaoLinhas = linhas;
      this.crmImportacaoErros = erros;
    };

    reader.readAsBinaryString(arquivo);
  }

  importarCrmLigacoes(modal: any) {
    if (this.crmImportacaoLinhas.length == 0) {
      this.toastr.warning("", "Selecione uma planilha para importar.");
      return;
    }

    if (this.crmImportacaoErros.length > 0) {
      this.toastr.warning("", "Corrija os erros da planilha antes de importar.");
      return;
    }

    this.crmImportando = true;

    this.callCenterService.importarCrmLigacoes(this.crmImportacaoLinhas).subscribe(
      resultado => {
        this.crmImportacaoErros = resultado.erros || [];

        if ((resultado.importados || 0) > 0) {
          this.toastr.success("", `${resultado.importados} ligacao(oes) importada(s) com sucesso.`);
          this.crmImportacaoAtualizarAoFechar = true;
        }

        if (this.crmImportacaoErros.length == 0) {
          modal.close();
          this.crmImportacaoAtualizarAoFechar = false;
          this.carregarCrmLigacoes();
        } else {
          this.toastr.warning("", "Alguns registros nao foram importados. Confira a lista de erros.");
        }
      },
      error => { console.log("Erro: " + error) },
      () => this.crmImportando = false
    );
  }

  fecharImportacaoCrmLigacoes(modal: any) {
    modal.dismiss();

    if (this.crmImportacaoAtualizarAoFechar) {
      this.crmImportacaoAtualizarAoFechar = false;
      this.carregarCrmLigacoes();
    }
  }

  private valorColunaImportacaoCrm(linha: any, coluna: string) {
    if (linha == null) {
      return null;
    }

    let chave = Object.keys(linha).find(item => item.toLowerCase().trim() == coluna.toLowerCase().trim());

    return chave == null ? null : linha[chave];
  }

  private normalizarDataImportacaoCrm(valor: any) {
    if (valor == null || valor == "") {
      return "";
    }

    if (valor instanceof Date && !isNaN(valor.getTime())) {
      return this.formatarDataImportacaoCrm(valor);
    }

    if (typeof valor == "number") {
      return this.formatarDataSerialExcelImportacaoCrm(valor);
    }

    let texto = valor.toString().trim();
    let dataBr = texto.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);

    if (dataBr != null) {
      return `${dataBr[3]}-${dataBr[2].padStart(2, "0")}-${dataBr[1].padStart(2, "0")}`;
    }

    let dataIso = texto.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);

    if (dataIso != null) {
      return `${dataIso[1]}-${dataIso[2].padStart(2, "0")}-${dataIso[3].padStart(2, "0")}`;
    }

    let data = new Date(texto);

    if (!isNaN(data.getTime())) {
      return this.formatarDataImportacaoCrm(data);
    }

    return "";
  }

  private formatarDataSerialExcelImportacaoCrm(serial: number) {
    let data = new Date(Date.UTC(1899, 11, 30));
    data.setUTCDate(data.getUTCDate() + Math.floor(serial));

    return this.formatarDataImportacaoCrm(data);
  }

  private formatarDataImportacaoCrm(data: Date) {
    let ano = data.getUTCFullYear().toString();
    let mes = (data.getUTCMonth() + 1).toString().padStart(2, "0");
    let dia = data.getUTCDate().toString().padStart(2, "0");

    return `${ano}-${mes}-${dia}`;
  }

  private formatarDataTelaImportacaoCrm(data: string) {
    let dataIso = (data || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);

    if (dataIso == null) {
      return data || "";
    }

    return `${dataIso[3]}/${dataIso[2]}/${dataIso[1]}`;
  }

  crmLigacoesPorEtapa(etapa: CallCenterCrmEtapa) {
    return this.crmLigacoes.filter(ligacao => ligacao.etapa_id == etapa.id);
  }

  crmLigacoesVisiveis(etapa: CallCenterCrmEtapa) {
    let limite = this.crmLigacoesVisiveisPorEtapa[etapa.id] || this.crmLigacoesLote;

    return this.crmLigacoesPorEtapa(etapa).slice(0, limite);
  }

  carregarMaisCrmLigacoesEtapa(etapa: CallCenterCrmEtapa, event: Event) {
    let elemento = event.target as HTMLElement;

    if (elemento == null) {
      return;
    }

    let chegouPertoDoFim = elemento.scrollTop + elemento.clientHeight >= elemento.scrollHeight - 160;

    if (!chegouPertoDoFim) {
      return;
    }

    let totalEtapa = this.crmLigacoesPorEtapa(etapa).length;
    let limiteAtual = this.crmLigacoesVisiveisPorEtapa[etapa.id] || this.crmLigacoesLote;

    if (limiteAtual >= totalEtapa) {
      return;
    }

    this.crmLigacoesVisiveisPorEtapa[etapa.id] = Math.min(limiteAtual + this.crmLigacoesLote, totalEtapa);
  }

  private resetarLotesCrmLigacoes() {
    this.crmLigacoesVisiveisPorEtapa = {};

    this.crmEtapas.forEach(etapa => {
      this.crmLigacoesVisiveisPorEtapa[etapa.id] = this.crmLigacoesLote;
    });
  }

  abrirCrmCalendarioFuturas(content: any) {
    this.abrirCrmCalendario(content, "FUTURAS");
  }

  abrirCrmCalendarioGeral(content: any) {
    if (!this.podeVisualizarCrmCalendarioGeral) {
      return;
    }

    this.abrirCrmCalendario(content, "TODAS");
  }

  abrirCrmCalendario(content: any, modo: string) {
    this.crmCalendarioModo = modo;

    let ligacoes = this.crmLigacoesCalendario();

    this.crmCalendarioDataReferencia = ligacoes.length > 0 ? new Date(ligacoes[0].data_ligacao) : new Date();
    this.crmCalendarioLigacaoSelecionada = null;
    this.crmCalendarioLigacoesSelecionadasIds = [];
    this.crmCalendarioNovaData = "";
    this.crmCalendarioFiltroVendInterna = "";
    this.montarCrmCalendario();

    this.modalService.open(content, { size: "xl", backdrop: "static" });
  }

  crmCalendarioModalTitulo() {
    if (this.crmCalendarioModo == "TODAS") {
      return "Calendario de ligacoes";
    }

    return "Calendario de ligacoes futuras";
  }

  crmLigacoesCalendario() {
    let filtrarVendInterna = (ligacao: CallCenterCrmLigacao) => {
      return this.crmCalendarioFiltroVendInterna == "" || (ligacao.vendinterna || "") == this.crmCalendarioFiltroVendInterna;
    };

    if (this.crmCalendarioModo == "TODAS") {
      return this.crmLigacoesOriginal
        .filter(ligacao => this.crmDataChave(ligacao.data_ligacao) != "")
        .filter(ligacao => ["ATRASADAS", "HOJE", "FUTURAS"].indexOf(ligacao.etapa_codigo) >= 0)
        .filter(ligacao => filtrarVendInterna(ligacao))
        .sort((a, b) => this.ordenarCrmLigacoesCalendario(a, b));
    }

    return this.crmLigacoesFuturasCalendario()
      .filter(ligacao => filtrarVendInterna(ligacao));
  }

  crmLigacoesFuturasCalendario() {
    return this.crmLigacoes
      .filter(ligacao => ligacao.etapa_codigo == "FUTURAS")
      .sort((a, b) => this.ordenarCrmLigacoesCalendario(a, b));
  }

  ordenarCrmLigacoesCalendario(a: CallCenterCrmLigacao, b: CallCenterCrmLigacao) {
    let dataA = this.crmDataChave(a.data_ligacao);
    let dataB = this.crmDataChave(b.data_ligacao);

    if (dataA == dataB) {
      return (a.name || "").localeCompare(b.name || "");
    }

    return dataA.localeCompare(dataB);
  }

  montarCrmCalendarioFuturas() {
    this.montarCrmCalendario();
  }

  montarCrmCalendario() {
    let ano = this.crmCalendarioDataReferencia.getFullYear();
    let mes = this.crmCalendarioDataReferencia.getMonth();
    let primeiroDiaSemana = new Date(ano, mes, 1).getDay();
    let ultimoDiaMes = new Date(ano, mes + 1, 0).getDate();
    let grupos = new Map<string, CallCenterCrmLigacao[]>();

    this.crmLigacoesCalendario().forEach(ligacao => {
      let chave = this.crmDataChave(ligacao.data_ligacao);

      if (chave != "") {
        if (!grupos.has(chave)) {
          grupos.set(chave, []);
        }

        grupos.get(chave).push(ligacao);
      }
    });

    let dias: any[] = [];

    for (let i = 0; i < primeiroDiaSemana; i++) {
      dias.push({ dia: null, data: "", ligacoes: [] });
    }

    for (let dia = 1; dia <= ultimoDiaMes; dia++) {
      let data = new Date(ano, mes, dia);
      let chave = this.crmDataChave(data);

      dias.push({
        dia: dia,
        data: chave,
        ligacoes: grupos.get(chave) || []
      });
    }

    this.crmCalendarioDias = dias;
  }

  crmCalendarioTitulo() {
    return this.datePipe.transform(this.crmCalendarioDataReferencia, "MM/yyyy");
  }

  crmCalendarioMesAnterior() {
    this.crmCalendarioDataReferencia = new Date(this.crmCalendarioDataReferencia.getFullYear(), this.crmCalendarioDataReferencia.getMonth() - 1, 1);
    this.crmCalendarioLigacaoSelecionada = null;
    this.crmCalendarioLigacoesSelecionadasIds = [];
    this.crmCalendarioNovaData = "";
    this.montarCrmCalendario();
  }

  crmCalendarioMesProximo() {
    this.crmCalendarioDataReferencia = new Date(this.crmCalendarioDataReferencia.getFullYear(), this.crmCalendarioDataReferencia.getMonth() + 1, 1);
    this.crmCalendarioLigacaoSelecionada = null;
    this.crmCalendarioLigacoesSelecionadasIds = [];
    this.crmCalendarioNovaData = "";
    this.montarCrmCalendario();
  }

  alterarFiltroVendInternaCrmCalendario() {
    this.crmCalendarioLigacaoSelecionada = null;
    this.crmCalendarioLigacoesSelecionadasIds = [];
    this.crmCalendarioNovaData = "";
    this.montarCrmCalendario();
  }

  selecionarCrmLigacaoCalendario(ligacao: CallCenterCrmLigacao) {
    if (ligacao == null) {
      return;
    }

    let index = this.crmCalendarioLigacoesSelecionadasIds.indexOf(ligacao.id);

    if (index >= 0) {
      this.crmCalendarioLigacoesSelecionadasIds.splice(index, 1);
    } else {
      this.crmCalendarioLigacoesSelecionadasIds.push(ligacao.id);
    }

    this.atualizarCrmCalendarioSelecao(ligacao);
  }

  crmCalendarioLigacaoMarcada(ligacao: CallCenterCrmLigacao) {
    return ligacao != null && this.crmCalendarioLigacoesSelecionadasIds.indexOf(ligacao.id) >= 0;
  }

  crmCalendarioDiaTemLigacoes(dia: any) {
    return dia != null && dia.ligacoes != null && dia.ligacoes.length > 0;
  }

  crmCalendarioDiaTodosSelecionados(dia: any) {
    return this.crmCalendarioDiaTemLigacoes(dia)
      && dia.ligacoes.every(ligacao => this.crmCalendarioLigacoesSelecionadasIds.indexOf(ligacao.id) >= 0);
  }

  selecionarTodasCrmCalendarioDia(dia: any, event: any) {
    if (!this.crmCalendarioDiaTemLigacoes(dia)) {
      return;
    }

    let selecionar = event != null && event.target != null ? event.target.checked : !this.crmCalendarioDiaTodosSelecionados(dia);

    dia.ligacoes.forEach(ligacao => {
      let index = this.crmCalendarioLigacoesSelecionadasIds.indexOf(ligacao.id);

      if (selecionar && index < 0) {
        this.crmCalendarioLigacoesSelecionadasIds.push(ligacao.id);
      }

      if (!selecionar && index >= 0) {
        this.crmCalendarioLigacoesSelecionadasIds.splice(index, 1);
      }
    });

    this.atualizarCrmCalendarioSelecao(dia.ligacoes.length > 0 ? dia.ligacoes[0] : null);
  }

  crmCalendarioLigacoesSelecionadas() {
    return this.crmLigacoesCalendario()
      .filter(ligacao => this.crmCalendarioLigacoesSelecionadasIds.indexOf(ligacao.id) >= 0);
  }

  crmCalendarioResumoSelecao() {
    let selecionadas = this.crmCalendarioLigacoesSelecionadas();

    if (selecionadas.length == 0) {
      return "Nenhuma ligacao selecionada";
    }

    if (selecionadas.length == 1) {
      return selecionadas[0].name;
    }

    return selecionadas.length + " ligacao(oes) selecionada(s)";
  }

  limparSelecaoCrmCalendario() {
    this.crmCalendarioLigacaoSelecionada = null;
    this.crmCalendarioLigacoesSelecionadasIds = [];
    this.crmCalendarioNovaData = "";
  }

  private atualizarCrmCalendarioSelecao(ligacaoReferencia: CallCenterCrmLigacao = null) {
    let selecionadas = this.crmCalendarioLigacoesSelecionadas();

    this.crmCalendarioLigacaoSelecionada = selecionadas.length == 1 ? selecionadas[0] : null;

    if (selecionadas.length == 0) {
      this.crmCalendarioNovaData = "";
      return;
    }

    if (this.crmCalendarioNovaData == "" && ligacaoReferencia != null) {
      this.crmCalendarioNovaData = this.crmDataChave(ligacaoReferencia.data_ligacao);
    }
  }

  salvarCrmCalendarioLigacaoData(modal: any) {
    this.salvarCrmCalendarioLigacoesData();
  }

  salvarCrmCalendarioLigacoesData() {
    let ids = this.crmCalendarioLigacoesSelecionadasIds.slice();

    if (ids.length == 0) {
      this.toastr.warning("", "Selecione ao menos uma ligacao.");
      return;
    }

    if (this.crmCalendarioNovaData == null || this.crmCalendarioNovaData == "") {
      this.toastr.warning("", "Informe a nova data da ligacao.");
      return;
    }

    this.callCenterService.updateCrmLigacoesData(ids, this.crmCalendarioNovaData).subscribe(
      retorno => {
        if (retorno) {
          let idsAtualizados = ids.slice();
          let dataAtualizada = this.crmDataValorLocal(this.crmCalendarioNovaData);

          this.crmLigacoesOriginal
            .filter(ligacao => idsAtualizados.indexOf(ligacao.id) >= 0)
            .forEach(ligacao => ligacao.data_ligacao = dataAtualizada);

          this.crmLigacoes
            .filter(ligacao => idsAtualizados.indexOf(ligacao.id) >= 0)
            .forEach(ligacao => ligacao.data_ligacao = dataAtualizada);

          this.toastr.success("", ids.length + " ligacao(oes) atualizada(s) com sucesso.");
          this.crmCalendarioDataReferencia = dataAtualizada;
          this.crmCalendarioLigacaoSelecionada = null;
          this.crmCalendarioLigacoesSelecionadasIds = [];
          this.crmCalendarioNovaData = "";
          this.recarregarCrmLigacoesCalendario();
        }
      }
    );
  }

  inativarCrmLigacoesSelecionadas() {
    if (!this.podeVisualizarCrmCalendarioGeral) {
      return;
    }

    let ids = this.crmCalendarioLigacoesSelecionadasIds.slice();

    if (ids.length == 0) {
      this.toastr.warning("", "Selecione ao menos uma ligacao.");
      return;
    }

    if (!confirm("Deseja inativar " + ids.length + " ligacao(oes) selecionada(s)?")) {
      return;
    }

    this.callCenterService.inativarCrmLigacoes(ids).subscribe(
      retorno => {
        if (retorno) {
          this.toastr.success("", ids.length + " ligacao(oes) inativada(s) com sucesso.");
          this.crmLigacoesOriginal = this.crmLigacoesOriginal.filter(ligacao => ids.indexOf(ligacao.id) == -1);
          this.crmLigacoes = this.crmLigacoes.filter(ligacao => ids.indexOf(ligacao.id) == -1);
          this.crmCalendarioLigacaoSelecionada = null;
          this.crmCalendarioLigacoesSelecionadasIds = [];
          this.crmCalendarioNovaData = "";
          this.aplicarFiltrosCrmLigacoes();
          this.montarCrmCalendario();
        }
      }
    );
  }

  inativarCrmLigacao(ligacao: CallCenterCrmLigacao, modal: any = null) {
    if (!this.podeVisualizarCrmCalendarioGeral || ligacao == null) {
      return;
    }

    if (!confirm("Deseja inativar esta ligacao?")) {
      return;
    }

    this.callCenterService.inativarCrmLigacao(ligacao.id).subscribe(
      retorno => {
        if (retorno) {
          this.toastr.success("", "Ligacao inativada com sucesso.");
          this.crmLigacoesOriginal = this.crmLigacoesOriginal.filter(item => item.id != ligacao.id);
          this.crmLigacoes = this.crmLigacoes.filter(item => item.id != ligacao.id);

          if (this.crmCalendarioLigacaoSelecionada != null && this.crmCalendarioLigacaoSelecionada.id == ligacao.id) {
            this.crmCalendarioLigacaoSelecionada = null;
            this.crmCalendarioNovaData = "";
          }

          this.crmCalendarioLigacoesSelecionadasIds = this.crmCalendarioLigacoesSelecionadasIds.filter(id => id != ligacao.id);

          this.aplicarFiltrosCrmLigacoes();
          this.montarCrmCalendario();
        }
      }
    );
  }

  abrirInativacaoMassaAtrasadas(content: any) {
    if (!this.podeVisualizarCrmCalendarioGeral) {
      return;
    }

    this.crmInativacaoMassaVendInterna = "";
    this.modalService.open(content, { size: "lg", backdrop: "static" });
  }

  crmLigacoesAtrasadasBase() {
    return this.crmLigacoesOriginal.filter(ligacao => ligacao.etapa_codigo == "ATRASADAS");
  }

  crmVendedorasInternasAtrasadas() {
    let vendedoras = new Set<string>();

    this.crmLigacoesAtrasadasBase()
      .forEach(ligacao => {
        let vendinterna = (ligacao.vendinterna || "").trim();

        if (vendinterna != "") {
          vendedoras.add(vendinterna);
        }
      });

    return Array.from(vendedoras).sort((a, b) => a.localeCompare(b));
  }

  qtdeCrmAtrasadasVendInterna(vendinterna: string) {
    return this.crmLigacoesAtrasadasBase().filter(ligacao => (ligacao.vendinterna || "").trim() == vendinterna).length;
  }

  inativarCrmAtrasadasVendInterna(modal: any) {
    if (!this.podeVisualizarCrmCalendarioGeral) {
      return;
    }

    if (this.crmInativacaoMassaVendInterna == "") {
      this.toastr.warning("", "Selecione uma vendedora interna.");
      return;
    }

    let ids = this.crmLigacoesAtrasadasBase()
      .filter(ligacao => (ligacao.vendinterna || "").trim() == this.crmInativacaoMassaVendInterna)
      .map(ligacao => ligacao.id);

    if (ids.length == 0) {
      this.toastr.warning("", "Nenhuma ligacao atrasada encontrada para a vendedora selecionada.");
      return;
    }

    if (!confirm("Deseja inativar " + ids.length + " ligacao(oes) atrasada(s) desta vendedora interna?")) {
      return;
    }

    this.callCenterService.inativarCrmLigacoes(ids).subscribe(
      retorno => {
        if (retorno) {
          this.toastr.success("", "Ligacoes inativadas com sucesso.");
          this.crmLigacoesOriginal = this.crmLigacoesOriginal.filter(ligacao => ids.indexOf(ligacao.id) == -1);
          this.crmLigacoes = this.crmLigacoes.filter(ligacao => ids.indexOf(ligacao.id) == -1);
          this.aplicarFiltrosCrmLigacoes();
          modal.close();
        }
      }
    );
  }

  private crmDataChave(valor: any) {
    if (valor == null || valor == "") {
      return "";
    }

    if (typeof valor == "string" && /^\d{4}-\d{2}-\d{2}$/.test(valor)) {
      return valor;
    }

    let data = valor instanceof Date ? valor : new Date(valor);

    if (isNaN(data.getTime())) {
      return "";
    }

    return this.datePipe.transform(data, "yyyy-MM-dd") || "";
  }

  private crmDataValorLocal(valor: string) {
    if (valor == null || valor == "") {
      return null;
    }

    let partes = valor.split("-").map(parte => parseInt(parte, 10));

    if (partes.length != 3 || partes.some(parte => isNaN(parte))) {
      return new Date(valor);
    }

    return new Date(partes[0], partes[1] - 1, partes[2]);
  }

  iniciarArrasteCrmBoard(event: PointerEvent) {
    let elemento = event.target as HTMLElement;

    if (elemento.closest("button, a, input, select, textarea")) {
      return;
    }

    let board = event.currentTarget as HTMLElement;

    this.crmBoardArrastando = true;
    this.crmBoardArrasteInicioX = event.clientX;
    this.crmBoardScrollInicio = board.scrollLeft;
    board.setPointerCapture(event.pointerId);
    event.preventDefault();
  }

  arrastarCrmBoard(event: PointerEvent) {
    if (!this.crmBoardArrastando) {
      return;
    }

    let board = event.currentTarget as HTMLElement;
    let distancia = event.clientX - this.crmBoardArrasteInicioX;

    board.scrollLeft = this.crmBoardScrollInicio - distancia;
  }

  finalizarArrasteCrmBoard() {
    this.crmBoardArrastando = false;
  }

  crmStatusClasse(status: string) {
    switch ((status || "").toLowerCase()) {
      case "venda realizada":
        return "crm-badge-success";
      case "não comprou":
      case "nao comprou":
        return "crm-badge-danger";
      case "agendada":
        return "crm-badge-warning";
      case "à ligar":
      case "a ligar":
        return "crm-badge-primary";
      case "retornar (proposta)":
      case "retornar (não estava)":
      case "retornar (nao estava)":
        return "crm-badge-purple";
      case "sem contato":
        return "crm-badge-muted";
      default:
        return "crm-badge-info";
    }
  }

  crmRelationshipClasse(relationship: string) {
    let valor = (relationship || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();

    switch (valor) {
      case "prospeccao":
        return "crm-client-prospeccao";
      case "inativo":
        return "crm-client-inativo";
      case "ativo":
        return "crm-client-ativo";
      case "ativo batido":
        return "crm-client-ativo-batido";
      case "ativo premium":
        return "crm-client-ativo-premium";
      default:
        return "crm-client-default";
    }
  }

  crmDataTexto(ligacao: CallCenterCrmLigacao) {
    if (ligacao.faixa_data == "HOJE") {
      return "Hoje";
    }

    if (ligacao.faixa_data == "FUTURA") {
      return "Futura em " + ligacao.dias_referencia + " dias";
    }

    if (ligacao.faixa_data == "ATRASADA") {
      return "Atrasada há " + ligacao.dias_referencia + " dias";
    }

    return ligacao.etapa_nome;
  }

  /* Dados */

  calcularDadosAnaliseSintetica() {
    /* Vendas do Dia */

    if (this.valorVendasDia > 0 && this.valorMetaDia > 0) {
      this.porcentagemVendasDia = ((this.valorVendasDia / this.valorMetaDia) * 100);
    }

    /* Ligações Sintéticas */

    if (this.visitas.length > 0) {
      /* Visitas */

      /* Este Mês */

      let dataInicial = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      let dataFinal = new Date();

      let visitasPorPeriodo = this.visitas.filter(visitas => {
        let data = this.datePipe.transform(visitas.check_in, "yyyy/MM/dd");

        return data >= this.datePipe.transform(dataInicial, "yyyy/MM/dd") && data <= this.datePipe.transform(dataFinal, "yyyy/MM/dd");
      });

      this.ligacoesSinteticas = [];

      let periodo: string = "Este Mês: " + this.datePipe.transform(dataInicial, "dd/MM/yyyy") + " - " + this.datePipe.transform(dataFinal, "dd/MM/yyyy");

      let qtdeLigacoes: number = visitasPorPeriodo.length;
      let qtdeVenda: number = visitasPorPeriodo.filter(visitaPorPerido => visitaPorPerido.callcenter_status == 4).length;
      let porcentagemVenda: number = qtdeVenda > 0 ? ((qtdeVenda / qtdeLigacoes) * 100) : 0;
      let qtdeLigacoesSemVenda: number = qtdeLigacoes - qtdeVenda;
      let porcentagemLigacoesSemVenda: number = qtdeLigacoesSemVenda > 0 ? ((qtdeLigacoesSemVenda / qtdeLigacoes) * 100) : 0;
      let qtdeLigacoesFeitas: number = visitasPorPeriodo.filter(visitaPorPerido => visitaPorPerido.callcenter_tipo == "F").length;
      let porcentagemLigacoesFeitas: number = qtdeLigacoesFeitas > 0 ? ((qtdeLigacoesFeitas / qtdeLigacoes) * 100) : 0;
      let qtdeLigacoesRecebidas: number = visitasPorPeriodo.filter(visitaPorPerido => visitaPorPerido.callcenter_tipo == "R").length;;
      let porcentagemLigacoesRecebidas: number = qtdeLigacoesRecebidas > 0 ? ((qtdeLigacoesRecebidas / qtdeLigacoes) * 100) : 0;
      let qtdeOutros: number = visitasPorPeriodo.filter(visitaPorPerido => visitaPorPerido.callcenter_tipo != "F" && visitaPorPerido.callcenter_tipo != "R").length;
      let porcentagemOutros: number = qtdeOutros > 0 ? ((qtdeOutros / qtdeLigacoes) * 100) : 0;

      this.ligacoesSinteticas.push(new CallCenterLigacaoSintetica(periodo, qtdeLigacoes, qtdeVenda, porcentagemVenda, qtdeLigacoesSemVenda, porcentagemLigacoesSemVenda, qtdeLigacoesFeitas, porcentagemLigacoesFeitas, qtdeLigacoesRecebidas, porcentagemLigacoesRecebidas, qtdeOutros, porcentagemOutros));

      /* Mês Anterior */

      dataInicial = new Date(dataInicial.setMonth(dataInicial.getMonth() - 1));

      let dataTemporariaMesAnterior = new Date(dataFinal.getFullYear(), dataFinal.getMonth() - 1, dataFinal.getDate());

      if (dataFinal.getDate() > dataTemporariaMesAnterior.getDate()) {
        dataFinal = new Date(dataTemporariaMesAnterior.getFullYear(), dataTemporariaMesAnterior.getMonth(), 0);
      } else {
        dataFinal = new Date(dataFinal.setMonth(dataFinal.getMonth() - 1));
      }

      visitasPorPeriodo = this.visitas.filter(visitaPorPeriodo => {
        let data = this.datePipe.transform(visitaPorPeriodo.check_in, "yyyy/MM/dd");

        return data >= this.datePipe.transform(dataInicial, "yyyy/MM/dd") && data <= this.datePipe.transform(dataFinal, "yyyy/MM/dd");
      });

      periodo = "Mês Anterior: " + this.datePipe.transform(dataInicial, "dd/MM/yyyy") + " - " + this.datePipe.transform(dataFinal, "dd/MM/yyyy");

      qtdeLigacoes = visitasPorPeriodo.length;
      qtdeVenda = visitasPorPeriodo.filter(visitaPorPerido => visitaPorPerido.callcenter_status == 4).length;
      porcentagemVenda = qtdeVenda > 0 ? ((qtdeVenda / qtdeLigacoes) * 100) : 0;
      qtdeLigacoesSemVenda = visitasPorPeriodo.filter(visitaPorPerido => visitaPorPerido.callcenter_status == 5).length;
      porcentagemLigacoesSemVenda = qtdeLigacoesSemVenda > 0 ? ((qtdeLigacoesSemVenda / qtdeLigacoes) * 100) : 0;
      qtdeLigacoesFeitas = visitasPorPeriodo.filter(visitaPorPerido => visitaPorPerido.callcenter_tipo == "F").length;
      porcentagemLigacoesFeitas = qtdeLigacoesFeitas > 0 ? ((qtdeLigacoesFeitas / qtdeLigacoes) * 100) : 0;
      qtdeLigacoesRecebidas = visitasPorPeriodo.filter(visitaPorPerido => visitaPorPerido.callcenter_tipo == "R").length;;
      porcentagemLigacoesRecebidas = qtdeLigacoesRecebidas > 0 ? ((qtdeLigacoesRecebidas / qtdeLigacoes) * 100) : 0;
      qtdeOutros = visitasPorPeriodo.filter(visitaPorPerido => visitaPorPerido.callcenter_tipo != "F" && visitaPorPerido.callcenter_tipo != "R").length;
      porcentagemOutros = qtdeOutros > 0 ? ((qtdeOutros / qtdeLigacoes) * 100) : 0;

      this.ligacoesSinteticas.push(new CallCenterLigacaoSintetica(periodo, qtdeLigacoes, qtdeVenda, porcentagemVenda, qtdeLigacoesSemVenda, porcentagemLigacoesSemVenda, qtdeLigacoesFeitas, porcentagemLigacoesFeitas, qtdeLigacoesRecebidas, porcentagemLigacoesRecebidas, qtdeOutros, porcentagemOutros));

      /* 2 Meses Atrás */

      dataInicial = new Date(dataInicial.setMonth(dataInicial.getMonth() - 1));

      let dataTemporariaDoisMeses = new Date(dataTemporariaMesAnterior.getFullYear(), dataTemporariaMesAnterior.getMonth() - 1, dataTemporariaMesAnterior.getDate());

      if (dataFinal.getDate() > dataTemporariaDoisMeses.getDate()) {
        dataFinal = new Date(dataTemporariaDoisMeses.getFullYear(), dataTemporariaDoisMeses.getMonth(), 0);
      } else {
        dataFinal = new Date(dataFinal.setMonth(dataFinal.getMonth() - 1));
      }

      visitasPorPeriodo = this.visitas.filter(visitaPorPeriodo => {
        let data = this.datePipe.transform(visitaPorPeriodo.check_in, "yyyy/MM/dd");

        return data >= this.datePipe.transform(dataInicial, "yyyy/MM/dd") && data <= this.datePipe.transform(dataFinal, "yyyy/MM/dd");
      });

      periodo = "2 Meses Atrás: " + this.datePipe.transform(dataInicial, "dd/MM/yyyy") + " - " + this.datePipe.transform(dataFinal, "dd/MM/yyyy");

      qtdeLigacoes = visitasPorPeriodo.length;
      qtdeVenda = visitasPorPeriodo.filter(visitaPorPerido => visitaPorPerido.callcenter_status == 4).length;
      porcentagemVenda = qtdeVenda > 0 ? ((qtdeVenda / qtdeLigacoes) * 100) : 0;
      qtdeLigacoesSemVenda = visitasPorPeriodo.filter(visitaPorPerido => visitaPorPerido.callcenter_status == 5).length;
      porcentagemLigacoesSemVenda = qtdeLigacoesSemVenda > 0 ? ((qtdeLigacoesSemVenda / qtdeLigacoes) * 100) : 0;
      qtdeLigacoesFeitas = visitasPorPeriodo.filter(visitaPorPerido => visitaPorPerido.callcenter_tipo == "F").length;
      porcentagemLigacoesFeitas = qtdeLigacoesFeitas > 0 ? ((qtdeLigacoesFeitas / qtdeLigacoes) * 100) : 0;
      qtdeLigacoesRecebidas = visitasPorPeriodo.filter(visitaPorPerido => visitaPorPerido.callcenter_tipo == "R").length;;
      porcentagemLigacoesRecebidas = qtdeLigacoesRecebidas > 0 ? ((qtdeLigacoesRecebidas / qtdeLigacoes) * 100) : 0;
      qtdeOutros = visitasPorPeriodo.filter(visitaPorPerido => visitaPorPerido.callcenter_tipo != "F" && visitaPorPerido.callcenter_tipo != "R").length;
      porcentagemOutros = qtdeOutros > 0 ? ((qtdeOutros / qtdeLigacoes) * 100) : 0;

      this.ligacoesSinteticas.push(new CallCenterLigacaoSintetica(periodo, qtdeLigacoes, qtdeVenda, porcentagemVenda, qtdeLigacoesSemVenda, porcentagemLigacoesSemVenda, qtdeLigacoesFeitas, porcentagemLigacoesFeitas, qtdeLigacoesRecebidas, porcentagemLigacoesRecebidas, qtdeOutros, porcentagemOutros));
    }
  }

  calcularDadosLigacoes() {
    this.pieChartData = { labels: [], datasets: [{ data: [], backgroundColor: [] }] };

    /* Call Center (Ligações) */

    /* Ligações Analíticas */

    if (this.ligacoesAnaliticas.length > 0) {
      /* Atenção/Ligações */

      this.qtdeLigacoes = this.ligacoesAnaliticas.length;
      this.qtdeRealizado = this.ligacoesAnaliticas[0].qtde_realizado;
      this.porcentagemQtdeRealizado = this.ligacoesAnaliticas[0].porcentagem_qtde_realizado;
      this.valorMetaDia = this.ligacoesAnaliticas[0].valor_meta_dia;

      /* À Ligar */

      let qtdeALigar: number = this.ligacoesAnaliticas.filter(ligacoesAnaliticas => ligacoesAnaliticas.status_name == "À Ligar").length;
      let porcentagemALigacar: number = ((qtdeALigar / this.ligacoesAnaliticas.length) * 100);

      if (qtdeALigar > 0) {
        (this.pieChartData.labels as string[]).push("À Ligar (" + qtdeALigar + ")");
        (this.pieChartData.datasets[0].data as number[]).push(parseInt(porcentagemALigacar.toFixed(0)));
        (this.pieChartData.datasets[0].backgroundColor as string[]).push("rgba(0, 123, 255, 1)");
      }

      /* Agendada */

      let qtdeAgendada: number = this.ligacoesAnaliticas.filter(ligacoesAnaliticas => ligacoesAnaliticas.status_name == "Agendada").length;
      let porcentagemQtdeAgendada: number = ((qtdeAgendada / this.ligacoesAnaliticas.length) * 100);

      if (qtdeAgendada > 0) {
        (this.pieChartData.labels as string[]).push("Agendada (" + qtdeAgendada + ")");
        (this.pieChartData.datasets[0].data as number[]).push(parseInt(porcentagemQtdeAgendada.toFixed(0)));
        (this.pieChartData.datasets[0].backgroundColor as string[]).push("rgba(255, 193, 7, 1)");
      }

      /* Não Comprou */

      let qtdeNaoComprou: number = this.ligacoesAnaliticas.filter(ligacoesAnaliticas => ligacoesAnaliticas.status_name == "Não Comprou").length;
      let porcentagemQtdeNaoComprou: number = ((qtdeNaoComprou / this.ligacoesAnaliticas.length) * 100);

      if (qtdeNaoComprou > 0) {
        (this.pieChartData.labels as string[]).push("Não Comprou (" + qtdeNaoComprou + ")");
        (this.pieChartData.datasets[0].data as number[]).push(parseInt(porcentagemQtdeNaoComprou.toFixed(0)));
        (this.pieChartData.datasets[0].backgroundColor as string[]).push("rgba(220, 53, 69, 1)");
      }

      /* Sem Contato */

      let qtdeSemContato: number = this.ligacoesAnaliticas.filter(ligacoesAnaliticas => ligacoesAnaliticas.status_name == "Sem Contato").length;
      let porcentagemQtdeSemContato: number = ((qtdeSemContato / this.ligacoesAnaliticas.length) * 100);

      if (qtdeSemContato > 0) {
        (this.pieChartData.labels as string[]).push("Sem Contato (" + qtdeSemContato + ")");
        (this.pieChartData.datasets[0].data as number[]).push(parseInt(porcentagemQtdeSemContato.toFixed(0)));
        (this.pieChartData.datasets[0].backgroundColor as string[]).push("rgba(108, 117, 125, 1)");
      }

      /* Retornar (Não Estava) */

      let qtdeRetornarNaoEstava: number = this.ligacoesAnaliticas.filter(ligacoesAnaliticas => ligacoesAnaliticas.status_name == "Retornar (Não Estava)").length;
      let porcentagemQtdeRetornarNaoEstava: number = ((qtdeRetornarNaoEstava / this.ligacoesAnaliticas.length) * 100);

      if (qtdeRetornarNaoEstava > 0) {
        (this.pieChartData.labels as string[]).push("Retornar (Não Estava) (" + qtdeRetornarNaoEstava + ")");
        (this.pieChartData.datasets[0].data as number[]).push(parseInt(porcentagemQtdeRetornarNaoEstava.toFixed(0)));
        (this.pieChartData.datasets[0].backgroundColor as string[]).push("rgba(138, 0, 230, 1)");
      }

      /* Retornar (Proposta) */

      let qtdeRetornarProposta: number = this.ligacoesAnaliticas.filter(ligacoesAnaliticas => ligacoesAnaliticas.status_name == "Retornar (Proposta)").length;
      let porcentagemQtdeRetornarProposta: number = ((qtdeRetornarProposta / this.ligacoesAnaliticas.length) * 100);

      if (qtdeRetornarProposta > 0) {
        (this.pieChartData.labels as string[]).push("Retornar (Proposta) (" + qtdeRetornarProposta + ")");
        (this.pieChartData.datasets[0].data as number[]).push(parseInt(porcentagemQtdeRetornarProposta.toFixed(0)));
        (this.pieChartData.datasets[0].backgroundColor as string[]).push("rgba(23, 162, 184, 1)");
      }

      /* Venda Realizada */

      let qtdeVendaRealizada: number = this.ligacoesAnaliticas.filter(ligacoesAnaliticas => ligacoesAnaliticas.status_name == "Venda Realizada").length;
      let porcentagemQtdeVendaRealizada: number = ((qtdeVendaRealizada / this.ligacoesAnaliticas.length) * 100);

      if (qtdeVendaRealizada > 0) {
        (this.pieChartData.labels as string[]).push("Venda Realizada (" + qtdeVendaRealizada + ")");
        (this.pieChartData.datasets[0].data as number[]).push(parseInt(porcentagemQtdeVendaRealizada.toFixed(0)));
        (this.pieChartData.datasets[0].backgroundColor as string[]).push("rgba(40, 167, 69, 1)");
      }
    }
  }

  calcularDadosOportunidades() {
    /* Call Center (Oportunidades) */

    if (this.oportunidades.length > 0) {
      /* Meta do Mês */

      this.valorMetaMes = this.oportunidades.reduce((sum, current) => sum + current.falta_vender, 0);

      /* Acompanhamento */

      this.qtdeClientes = this.oportunidades.length;
      this.qtdeClientesPadrao = this.oportunidades.filter(oportunidades => oportunidades.origem == "CARTEIRA").length;
      this.qtdeClientesAdicionais = this.oportunidades.filter(oportunidades => oportunidades.origem == "ADICIONAL").length;

      /* Estatística (Clientes) */

      this.estatisticasClientes = [];

      /* Ativo */

      let qtdeAtivo = this.oportunidades.filter(oportunidades => oportunidades.relationship == "Ativo").length;
      let porcentagemAtivo = 0;

      if (qtdeAtivo > 0) {
        porcentagemAtivo = ((qtdeAtivo / this.qtdeClientes) * 100);
      }

      this.estatisticasClientes.push(new Estatistica("ativo", "Ativo", qtdeAtivo, null, qtdeAtivo, porcentagemAtivo));

      /* Ativo batido */

      let qtdeAtivoBatido = this.oportunidades.filter(oportunidades => oportunidades.relationship == "Ativo batido").length;
      let porcentagemAtivoBatido = 0;

      if (qtdeAtivoBatido > 0) {
        porcentagemAtivoBatido = ((qtdeAtivoBatido / this.qtdeClientes) * 100);
      }

      this.estatisticasClientes.push(new Estatistica("ativo_batido", "Ativo (Batido)", qtdeAtivoBatido, null, qtdeAtivoBatido, porcentagemAtivoBatido));

      /* Ativo Premium */

      let qtdeAtivoPremium = this.oportunidades.filter(oportunidades => oportunidades.relationship == "Ativo Premium").length;
      let porcentagemAtivoPremium = 0;

      if (qtdeAtivoPremium > 0) {
        porcentagemAtivoPremium = ((qtdeAtivoPremium / this.qtdeClientes) * 100);
      }

      this.estatisticasClientes.push(new Estatistica("ativo_premium", "Ativo (Premium)", qtdeAtivoPremium, null, qtdeAtivoPremium, porcentagemAtivoPremium));

      /* Inativo */

      let qtdeInativo = this.oportunidades.filter(oportunidades => oportunidades.relationship == "Inativo").length;
      let porcentagemInativo = 0;

      if (qtdeInativo > 0) {
        porcentagemInativo = ((qtdeInativo / this.qtdeClientes) * 100);
      }

      this.estatisticasClientes.push(new Estatistica("inativo", "Inativo", qtdeInativo, null, qtdeInativo, porcentagemInativo));

      /* Prospecção */

      let qtdeProspeccao = this.oportunidades.filter(oportunidades => oportunidades.relationship == "Prospecção").length;
      let porcentagemProspeccao = 0;

      if (qtdeProspeccao > 0) {
        porcentagemProspeccao = ((qtdeProspeccao / this.qtdeClientes) * 100);
      }

      this.estatisticasClientes.push(new Estatistica("prospeccao", "Prospecção", qtdeProspeccao, null, qtdeProspeccao, porcentagemProspeccao));

      this.estatisticasClientes.sort((a, b) => {
        const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

        return compare(a["qtde"], b["qtde"]) * -1; /* Decrescente */
      });
    }
  }

  carregarDadosLigacoes() {
    this.carregando = true;

    /* Call Center (Configurações) */

    this.callCenterService.getConfiguracaoByGuidClienteNapis().subscribe(
      callCenterConfiguracao => this.callCenterConfiguracao = callCenterConfiguracao,
      error => { console.log("Erro: " + error) },
      () => {
        /* Ordernar (Ligações) */

        if (this.callCenterConfiguracao != null && this.callCenterConfiguracao.mostra_classificacao) {
          let classificacao = this.ordernarLigacoesOpcoes.find(opcao => opcao.valor == "classificacao");

          if (classificacao == null) {
            this.ordernarLigacoesOpcoes.push(
              { texto: "Classificação", valor: "classificacao" }
            );
          }
        }

        this.ordernarLigacoesOrganizarOpcoes();

        /* Ordernar (Oportunidades) */

        if (this.callCenterConfiguracao != null && this.callCenterConfiguracao.mostra_classificacao) {
          let classificacao = this.ordernarOportunidadesOpcoes.find(opcao => opcao.valor == "classificacao");

          if (classificacao == null) {
            this.ordernarOportunidadesOpcoes.push(
              { texto: "Classificação", valor: "classificacao" }
            );
          }
        }

        this.ordernarOportunidadesOrganizarOpcoes();

        /* Call Center (Ligações) */

        /* Ligações Analíticas */

        let atencao: boolean = false;

        if (this.tabSelecionada == "atencao") {
          atencao = true;
        }

        this.callCenterService.getLigacaoByUsuario(atencao).subscribe(
          ligacoesAnaliticas => this.ligacoesAnaliticas = ligacoesAnaliticas,
          error => { console.log("Erro: " + error) },
          () => {
            this.ajustarLigacoes(false);
            this.calcularDadosLigacoes();

            /* Visitas */

            this.visitaService.getVisitaByUsuario().subscribe(
              visitas => this.visitas = visitas,
              error => { console.log("Erro: " + error) },
              () => {
                this.verificarFiltro();

                this.carregando = false;
              }
            );
          }
        );
      }
    );
  }

  carregarDadosClassificacao() {
    if (this.filtroClassificacoes.length == 0) {
      this.carregando = true;

      this.callCenterService.getOportunidadeClassificacaoByGuidClienteNapis().subscribe(
        filtroClassificacoes => this.filtroClassificacoes = filtroClassificacoes,
        error => { console.log("Erro: " + error) },
        () => {
          /* Ordernar */

          if (this.callCenterConfiguracao != null && this.callCenterConfiguracao.mostra_classificacao) {
            let classificacao = this.ordernarLigacoesOpcoes.find(opcao => opcao.valor == "classificacao");

            if (classificacao == null) {
              this.ordernarLigacoesOpcoes.push(
                { texto: "Classificação", valor: "classificacao" }
              );
            }

            classificacao = this.ordernarOportunidadesOpcoes.find(opcao => opcao.valor == "classificacao");

            if (classificacao == null) {
              this.ordernarOportunidadesOpcoes.push(
                { texto: "Classificação", valor: "classificacao" }
              );
            }
          }

          this.ordernarOportunidadesOrganizarOpcoes();

          this.carregando = false;
        }
      );
    }
  }

  /* Exportar */

  exportarOportunidades() {
    this.excelService.exportAsExcelFile(this.oportunidades, "Oportunidades");
  }

  /* Filtros */

  alterarFiltro(filtro_selecionado: string, carregando_filtro?: boolean) {
    let retorno = new Promise<void>((resolver) => {
      if (filtro_selecionado == "1") { /* Classificação */
        this.carregarDadosClassificacao();
      }

      switch (this.tabSelecionada) {
        case "atencao":
        case "ligacoes":
          // Atenção
          // Ligações

          this.ligacoesAnaliticas = this.ligacoesAnaliticasOriginal;

          this.calcularDadosLigacoes();

          break;
        case "oportunidades":
          // Oportunidades

          /* Call Center (Oportunidades) */

          this.oportunidades = [];

          this.calcularDadosOportunidades();

          break;
        default:
          break;
      }

      let filtroAtual: string = this.formFiltro.controls["filtro"].value;

      this.formFiltro.reset();

      if (filtro_selecionado == null) {
        this.formFiltro.controls["filtro"].setValue(filtroAtual);

        this.apagarFiltroArmazenado();
      } else {
        this.formFiltro.controls["filtro"].setValue(filtro_selecionado);

        if (!carregando_filtro && filtro_selecionado != filtroAtual) {
          this.apagarFiltroArmazenado();
        }
      }

      this.organizarFiltro();

      this.enviado = false;
      this.filtrado = false;
      this.filtradoVendedor = false;

      this.tagFiltroErro = false;

      /* Dados */

      /* Filtro (Produtos) */

      this.enviadoProduto = false;
      this.produtoSelecionado = null;

      if (this.formFiltro.controls["filtro"].value == "7" && this.produtosOriginal.length == 0) { /* Produto */
        this.produtoService.getByGuidClienteNapis().subscribe(
          produtos => this.produtos = produtos,
          error => { console.log("Erro: " + error) },
          () => {
            this.produtosOriginal = JSON.parse(JSON.stringify(this.produtos));

            return resolver();
          }
        );
      } else {
        return resolver();
      }
    });

    return retorno;
  }

  apagarFiltroArmazenado() {
    localStorage.removeItem("call_center_aba");
    localStorage.removeItem("call_center_filtro");
    localStorage.removeItem("call_center_filtro_vendedor");

    /* Cidade */

    localStorage.removeItem("call_center_filtro_cidade");

    /* Classificação */

    localStorage.removeItem("call_center_filtro_classificacao");

    /* Cliente */

    localStorage.removeItem("call_center_filtro_cliente");

    /* CNPJ/CPF */

    localStorage.removeItem("call_center_filtro_cnpj_cpf");

    /* Código */

    localStorage.removeItem("call_center_filtro_codigo");

    /* Dias sem Compra */

    localStorage.removeItem("call_center_filtro_nro_inicial_sem_compra");
    localStorage.removeItem("call_center_filtro_nro_final_sem_compra");

    /* Dias sem Visita */

    localStorage.removeItem("call_center_filtro_nro_inicial_sem_visita");
    localStorage.removeItem("call_center_filtro_nro_final_sem_visita");

    /* Realizado Ano */

    localStorage.removeItem("call_center_filtro_valor_inicial_realizado_ano");
    localStorage.removeItem("call_center_filtro_valor_final_realizado_ano");

    /* Realizado Mês */

    localStorage.removeItem("call_center_filtro_valor_inicial_realizado_mes");
    localStorage.removeItem("call_center_filtro_valor_final_realizado_mes");

    /* Segmento */

    localStorage.removeItem("call_center_filtro_segmento");

    /* Tags */

  }

  armazenarFiltro() {
    this.apagarFiltroArmazenado();

    localStorage.setItem("call_center_aba", this.tabSelecionada);

    localStorage.setItem("call_center_filtro", this.formFiltro.controls["filtro"].value);

    if (this.formFiltro.controls["filtro"].value == "0") {
      /* Cidade */

      localStorage.setItem("call_center_filtro_cidade", this.formFiltro.controls["cidade"].value == null ? "" : this.formFiltro.controls["cidade"].value);
    } else if (this.formFiltro.controls["filtro"].value == "1") {
      /* Classificação */

      localStorage.setItem("call_center_filtro_classificacao", this.formFiltro.controls["classificacao"].value == null ? "" : this.formFiltro.controls["classificacao"].value);
    } else if (this.formFiltro.controls["filtro"].value == "2") {
      /* Cliente */

      localStorage.setItem("call_center_filtro_cliente", this.formFiltro.controls["cliente"].value == null ? "" : this.formFiltro.controls["cliente"].value);
    } else if (this.formFiltro.controls["filtro"].value == "3") {
      /* CNPJ/CPF */

      localStorage.setItem("call_center_filtro_cnpj_cpf", this.formFiltro.controls["cnpj_cpf"].value == null ? "" : this.formFiltro.controls["cnpj_cpf"].value);
    } else if (this.formFiltro.controls["filtro"].value == "4") {
      /* Código */

      localStorage.setItem("call_center_filtro_codigo", this.formFiltro.controls["codigo"].value == null ? "" : this.formFiltro.controls["codigo"].value);
    } else if (this.formFiltro.controls["filtro"].value == "5") {
      /* Dias sem Compra */

      localStorage.setItem("call_center_filtro_nro_inicial_sem_compra", this.formFiltro.controls["nro_inicial_sem_compra"].value == null ? "" : this.formFiltro.controls["nro_inicial_sem_compra"].value);

      if (
        this.formFiltro.controls["nro_final_sem_compra"] != null &&
        this.formFiltro.controls["nro_final_sem_compra"].value != null &&
        this.formFiltro.controls["nro_final_sem_compra"].value != ""
      ) {
        localStorage.setItem("call_center_filtro_nro_final_sem_compra", this.formFiltro.controls["nro_final_sem_compra"].value);
      }
    } else if (this.formFiltro.controls["filtro"].value == "6") {
      /* Dias sem Visita */

      localStorage.setItem("call_center_filtro_nro_inicial_sem_visita", this.formFiltro.controls["nro_inicial_sem_visita"].value == null ? "" : this.formFiltro.controls["nro_inicial_sem_visita"].value);

      if (
        this.formFiltro.controls["nro_final_sem_visita"] != null &&
        this.formFiltro.controls["nro_final_sem_visita"].value != null &&
        this.formFiltro.controls["nro_final_sem_visita"].value != ""
      ) {
        localStorage.setItem("call_center_filtro_nro_final_sem_visita", this.formFiltro.controls["nro_final_sem_visita"].value);
      }
    } else if (this.formFiltro.controls["filtro"].value == "7") {
      /* Produto */

      localStorage.setItem("call_center_filtro_produto", this.produtoSelecionado.id == null ? "" : this.produtoSelecionado.id.toString());
    } else if (this.formFiltro.controls["filtro"].value == "8") {
      /* Realizado Ano */

      localStorage.setItem("call_center_filtro_valor_inicial_realizado_ano", this.formFiltro.controls["valor_inicial_realizado_ano"].value == null ? "" : this.formFiltro.controls["valor_inicial_realizado_ano"].value);

      if (
        this.formFiltro.controls["valor_final_realizado_ano"] != null &&
        this.formFiltro.controls["valor_final_realizado_ano"].value != null &&
        this.formFiltro.controls["valor_final_realizado_ano"].value != ""
      ) {
        localStorage.setItem("call_center_filtro_valor_final_realizado_ano", this.formFiltro.controls["valor_final_realizado_ano"].value);
      }
    } else if (this.formFiltro.controls["filtro"].value == "9") {
      /* Realizado Mês */

      localStorage.setItem("call_center_filtro_valor_inicial_realizado_mes", this.formFiltro.controls["valor_inicial_realizado_mes"].value == null ? "" : this.formFiltro.controls["valor_inicial_realizado_mes"].value);

      if (
        this.formFiltro.controls["valor_final_realizado_mes"] != null &&
        this.formFiltro.controls["valor_final_realizado_mes"].value != null &&
        this.formFiltro.controls["valor_final_realizado_mes"].value != ""
      ) {
        localStorage.setItem("call_center_filtro_valor_final_realizado_mes", this.formFiltro.controls["valor_final_realizado_mes"].value);
      }
    } else if (this.formFiltro.controls["filtro"].value == "10") {
      /* Segmento */

      localStorage.setItem("call_center_filtro_segmento", this.formFiltro.controls["segmento"].value == null ? "" : this.formFiltro.controls["segmento"].value);
    } else if (this.formFiltro.controls["filtro"].value == "11") {
      /* Tags */

      localStorage.setItem("call_center_filtro_tags", JSON.stringify(this.tagFiltro));
    }

    localStorage.setItem("call_center_filtro_vendedor", this.formFiltro.controls["vendedor"].value == null ? "" : this.formFiltro.controls["vendedor"].value);
  }

  filtrar() {
    this.enviado = true;

    if (this.formFiltro.valid || (this.formFiltro.controls["vendedor"].value != "" && this.formFiltro.controls["vendedor"].value != null)) {
      this.filtrado = true;

      /* Tags */

      if (this.formFiltro.controls["filtro"].value == "11") {
        if (this.tagFiltro.length == 0 && (this.formFiltro.controls["vendedor"].value == "" || this.formFiltro.controls["vendedor"].value == null)) {
          /* Filtros */

          this.filtradoVendedor = false;

          /* Tags */

          this.tagFiltroErro = true;

          return;
        } else {
          this.tagFiltroErro = false;
        }
      } else {
        this.tagFiltroErro = false;
      }

      let filtrar = new CallCenterOportunidadeFiltrar();

      if (this.formFiltro.valid) {
        if (this.formFiltro.controls["filtro"].value == "0") {
          /* Cidade */

          if (this.formFiltro.controls["cidade"].value != "" && this.formFiltro.controls["cidade"].value != null) {
            filtrar.cidade = this.formFiltro.controls["cidade"].value;
          }
        } else if (this.formFiltro.controls["filtro"].value == "1") {
          /* Classificação */

          if (this.formFiltro.controls["classificacao"].value != "" && this.formFiltro.controls["classificacao"].value != null) {
            filtrar.classificacao = this.formFiltro.controls["classificacao"].value;
          }
        } else if (this.formFiltro.controls["filtro"].value == "2") {
          /* Cliente */

          if (this.formFiltro.controls["cliente"].value != "" && this.formFiltro.controls["cliente"].value != null) {
            filtrar.cliente = this.formFiltro.controls["cliente"].value;
          }
        } else if (this.formFiltro.controls["filtro"].value == "3") {
          /* CNPJ/CPF */

          if (this.formFiltro.controls["cnpj_cpf"].value != "" && this.formFiltro.controls["cnpj_cpf"].value != null) {
            let cnpj_cpf: string = this.formFiltro.controls["cnpj_cpf"].value.trim().split(".").join("").split("-").join("").split("/").join("");

            filtrar.cnpj_cpf = cnpj_cpf;
          }
        } else if (this.formFiltro.controls["filtro"].value == "4") {
          /* Código */

          if (this.formFiltro.controls["codigo"].value != "" && this.formFiltro.controls["codigo"].value != null) {
            filtrar.codigo = this.formFiltro.controls["codigo"].value;
          }
        } else if (this.formFiltro.controls["filtro"].value == "5") {
          /* Dias sem Compra */

          filtrar.nro_inicial_sem_compra = this.formFiltro.controls["nro_inicial_sem_compra"].value;

          if (this.formFiltro.controls["nro_final_sem_compra"].value != "" && this.formFiltro.controls["nro_final_sem_compra"].value != null) {
            filtrar.nro_final_sem_compra = this.formFiltro.controls["nro_final_sem_compra"].value;
          }
        } else if (this.formFiltro.controls["filtro"].value == "6") {
          /* Dias sem Visita */

          filtrar.nro_inicial_sem_visita = this.formFiltro.controls["nro_inicial_sem_visita"].value;

          if (this.formFiltro.controls["nro_final_sem_visita"].value != "" && this.formFiltro.controls["nro_final_sem_visita"].value != null) {
            filtrar.nro_final_sem_visita = this.formFiltro.controls["nro_final_sem_visita"].value
          }
        } else if (this.formFiltro.controls["filtro"].value == "7") {
          /* Produto */

          if (this.produtoSelecionado != null) {
            filtrar.id_produto = this.produtoSelecionado.id;
          }
        } else if (this.formFiltro.controls["filtro"].value == "8") {
          /* Realizado Ano */

          filtrar.valor_inicial_realizado_ano = this.formFiltro.controls["valor_inicial_realizado_ano"].value;

          if (this.formFiltro.controls["valor_final_realizado_ano"].value != "" && this.formFiltro.controls["valor_final_realizado_ano"].value != null) {
            filtrar.valor_final_realizado_ano = this.formFiltro.controls["valor_final_realizado_ano"].value
          }
        } else if (this.formFiltro.controls["filtro"].value == "9") {
          /* Realizado Mês */

          filtrar.valor_inicial_realizado_mes = this.formFiltro.controls["valor_inicial_realizado_mes"].value;

          if (this.formFiltro.controls["valor_final_realizado_mes"].value != "" && this.formFiltro.controls["valor_final_realizado_mes"].value != null) {
            filtrar.valor_final_realizado_mes = this.formFiltro.controls["valor_final_realizado_mes"].value;
          }
        } else if (this.formFiltro.controls["filtro"].value == "10") {
          /* Segmento */

          if (this.formFiltro.controls["segmento"].value != "" && this.formFiltro.controls["segmento"].value != null) {
            filtrar.segmento = this.formFiltro.controls["segmento"].value;
          }
        } else if (this.formFiltro.controls["filtro"].value == "11") {
          /* Tags */

          this.tagFiltro.forEach((item) => {
            filtrar.tags.push(item.tagValue.toLowerCase());
          });
        }
      }

      if (this.formFiltro.controls["vendedor"].value != "" && this.formFiltro.controls["vendedor"].value != null) {
        /* Vendedor(a) */

        filtrar.vendedor = this.formFiltro.controls["vendedor"].value;

        this.filtradoVendedor = true;
      }

      switch (this.tabSelecionada) {
        case "atencao":
        case "ligacoes":
          // Atenção
          // Ligações

          this.ligacoesAnaliticas = this.ligacoesAnaliticasOriginal;

          let filtroParcialInicial: boolean = false;

          if (this.formFiltro.controls["filtro"].value == "0") {
            /* Cidade */

            if (this.formFiltro.controls["cidade"].value != "" && this.formFiltro.controls["cidade"].value != null) {
              this.ligacoesAnaliticas = this.ligacoesAnaliticas.filter(ligacaoAnalitica => {
                return (ligacaoAnalitica.cidade.toLowerCase().indexOf(filtrar.cidade.trim().toLowerCase()) !== -1);
              });

              filtroParcialInicial = true;
            }
          } else if (this.formFiltro.controls["filtro"].value == "1") {
            /* Classificação */

            if (filtrar.classificacao != "" && filtrar.classificacao != null) {
              this.ligacoesAnaliticas = this.ligacoesAnaliticas.filter(ligacaoAnalitica => {
                return (ligacaoAnalitica.classificacao == filtrar.classificacao);
              });

              filtroParcialInicial = true;
            }
          } else if (this.formFiltro.controls["filtro"].value == "2") {
            /* Cliente */

            if (filtrar.cliente != "" && filtrar.cliente != null) {
              this.ligacoesAnaliticas = this.ligacoesAnaliticas.filter(ligacaoAnalitica => {
                return (ligacaoAnalitica.name.toLowerCase().indexOf(filtrar.cliente.trim().toLowerCase()) !== -1);
              });

              filtroParcialInicial = true;
            }
          } else if (this.formFiltro.controls["filtro"].value == "3") {
            /* CNPJ/CPF */

            if (filtrar.cnpj_cpf != "" && filtrar.cnpj_cpf != null) {
              let cnpj_cpf: string = filtrar.cnpj_cpf.split(".").join("").split("-").join("").split("/").join("");

              this.ligacoesAnaliticas = this.ligacoesAnaliticas.filter(ligacaoAnalitica => {
                let cnpj_cpf_filtro: string = ligacaoAnalitica.client_document != null ? ligacaoAnalitica.client_document.split(".").join("").split("-").join("").split("/").join("") : "";

                return cnpj_cpf_filtro == cnpj_cpf;
              });

              filtroParcialInicial = true;
            }
          } else if (this.formFiltro.controls["filtro"].value == "4") {
            /* Código */

            if (filtrar.codigo != "" && filtrar.codigo != null) {
              this.ligacoesAnaliticas = this.ligacoesAnaliticas.filter(ligacaoAnalitica => {
                return ligacaoAnalitica.codigo_no_erp_do_cliente.toLowerCase() == filtrar.codigo.trim().toLowerCase();
              });

              filtroParcialInicial = true;
            }
          } else if (this.formFiltro.controls["filtro"].value == "5") {
            /* Dias sem Compra */

            if (filtrar.nro_inicial_sem_compra != null && filtrar.nro_final_sem_compra != null) {
              this.ligacoesAnaliticas = this.ligacoesAnaliticas.filter(ligacaoAnalitica => {
                return (ligacaoAnalitica.qtdediasultcompra >= filtrar.nro_inicial_sem_compra && ligacaoAnalitica.qtdediasultcompra <= filtrar.nro_final_sem_compra);
              });
            } else if (filtrar.nro_inicial_sem_compra != null) {
              this.ligacoesAnaliticas = this.ligacoesAnaliticas.filter(ligacaoAnalitica => {
                return (ligacaoAnalitica.qtdediasultcompra >= filtrar.nro_inicial_sem_compra || ligacaoAnalitica.qtdediasultcompra == null);
              });
            }

            filtroParcialInicial = true;
          } else if (this.formFiltro.controls["filtro"].value == "6") {
            /* Dias sem Visita */

            if (filtrar.nro_inicial_sem_visita != null && filtrar.nro_final_sem_visita != null) {
              this.ligacoesAnaliticas = this.ligacoesAnaliticas.filter(ligacaoAnalitica => {
                return (ligacaoAnalitica.qtdediasultvis >= filtrar.nro_inicial_sem_visita && ligacaoAnalitica.qtdediasultvis <= filtrar.nro_final_sem_visita);
              });
            } else if (filtrar.nro_inicial_sem_visita != null) {
              this.ligacoesAnaliticas = this.ligacoesAnaliticas.filter(ligacaoAnalitica => {
                return (ligacaoAnalitica.qtdediasultvis >= filtrar.nro_inicial_sem_visita || ligacaoAnalitica.qtdediasultvis == null);
              });
            }

            filtroParcialInicial = true;
          } else if (this.formFiltro.controls["filtro"].value == "7") {
            /* Produto */

            if (filtrar.id_produto != null) {
              filtroParcialInicial = true;

              /* Ligações Analíticas */

              let atencao: boolean = false;

              if (this.tabSelecionada == "atencao") {
                atencao = true;
              }

              this.callCenterService.getLigacaoByUsuario(atencao, filtrar.id_produto).subscribe(
                ligacoesAnaliticas => this.ligacoesAnaliticas = ligacoesAnaliticas,
                error => { console.log("Erro: " + error) },
                () => {
                  this.ajustarLigacoes(true);
                  this.calcularDadosLigacoes();
                }
              );
            }
          } else if (this.formFiltro.controls["filtro"].value == "8") {
            /* Realizado Ano */

            if (filtrar.valor_inicial_realizado_ano != null && filtrar.valor_final_realizado_ano != null) {
              this.ligacoesAnaliticas = this.ligacoesAnaliticas.filter(ligacaoAnalitica => {
                return (ligacaoAnalitica.realizado_ano >= filtrar.valor_inicial_realizado_ano && ligacaoAnalitica.realizado_ano <= filtrar.valor_final_realizado_ano);
              });
            } else if (filtrar.valor_inicial_realizado_ano != null) {
              this.ligacoesAnaliticas = this.ligacoesAnaliticas.filter(ligacaoAnalitica => {
                return (ligacaoAnalitica.realizado_ano >= filtrar.valor_inicial_realizado_ano || ligacaoAnalitica.realizado_ano == null);
              });
            }

            filtroParcialInicial = true;
          } else if (this.formFiltro.controls["filtro"].value == "9") {
            /* Realizado Mês */

            if (filtrar.valor_inicial_realizado_mes != null && filtrar.valor_final_realizado_mes != null) {
              this.ligacoesAnaliticas = this.ligacoesAnaliticas.filter(ligacaoAnalitica => {
                return (ligacaoAnalitica.realizado_venda >= filtrar.valor_inicial_realizado_mes && ligacaoAnalitica.realizado_venda <= filtrar.valor_final_realizado_mes);
              });
            } else if (filtrar.valor_inicial_realizado_mes != null) {
              this.ligacoesAnaliticas = this.ligacoesAnaliticas.filter(ligacaoAnalitica => {
                return (ligacaoAnalitica.realizado_venda >= filtrar.valor_inicial_realizado_mes || ligacaoAnalitica.realizado_venda == null);
              });
            }

            filtroParcialInicial = true;
          } else if (this.formFiltro.controls["filtro"].value == "10") {
            /* Segmento */

            if (filtrar.segmento != "" && filtrar.segmento != null) {
              this.ligacoesAnaliticas = this.ligacoesAnaliticas.filter(ligacaoAnalitica => {
                return (ligacaoAnalitica.segment != null && ligacaoAnalitica.segment.toLowerCase().indexOf(filtrar.segmento.trim().toLowerCase()) !== -1);
              });

              filtroParcialInicial = true;
            }
          } else if (this.formFiltro.controls["filtro"].value == "11") {
            /* Tags */

            if (this.tagFiltro.length > 0) {
              this.ligacoesAnaliticas = this.ligacoesAnaliticas.filter(ligacaoAnalitica => {
                let tag: any = null;

                this.tagFiltro.forEach((item) => {
                  tag = ligacaoAnalitica.cliente_tags.find(tag => tag.descricao.toLowerCase() == item.tagValue.toLowerCase());
                });

                return tag != null;
              });

              filtroParcialInicial = true;
            }
          }

          let filtroParcialFinal: boolean = false;

          if (filtrar.vendedor != "" && filtrar.vendedor != null) {
            /* Vendedor(a) */

            this.ligacoesAnaliticas = this.ligacoesAnaliticas.filter(ligacaoAnalitica => {
              return (ligacaoAnalitica.fullname.toLowerCase().indexOf(filtrar.vendedor.trim().toLowerCase()) !== -1);
            });

            filtroParcialFinal = true;
          }

          if (filtroParcialInicial || filtroParcialFinal) {
            this.armazenarFiltro();
            this.calcularDadosLigacoes();
          } else {
            this.enviado = false;
            this.filtrado = false;
            this.filtradoVendedor = false;
          }

          if (this.ligacoesAnaliticas.length == 0) {
            this.toastr.error("", "Nenhuma ligação encontrada!");
          }

          break;
        case "oportunidades":
          // Oportunidades

          /* Call Center (Oportunidades) */

          this.oportunidades = [];

          this.callCenterService.getOportunidadeByUsuario(filtrar).subscribe(
            oportunidades => this.oportunidades = oportunidades,
            error => { console.log("Erro: " + error) },
            () => {
              this.oportunidades.forEach((item) => {
                if ((item.objetivo_de_venda - item.order_total) < 0) {
                  item.falta_vender = 0;
                } else {
                  item.falta_vender = item.objetivo_de_venda - item.order_total;
                }
              });

              if (this.modelo_tela_ligacoes == 1) {
                /* Modelo 2 */

                this.oportunidades.sort((a, b) => {
                  const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

                  return compare(a["ultvisita"], b["ultvisita"]);
                });

                this.ordernarOportunidadesSelecionado = "ultvisita";
              }

              this.calcularDadosOportunidades();

              if (this.oportunidades.length == 0) {
                this.toastr.error("", "Nenhuma oportunidade encontrada!");
              }
            }
          );

          this.armazenarFiltro();

          break;
        default:
          break;
      }
    }
  }

  organizarFiltro() {
    if (this.formFiltro.controls["filtro"].value == "0") {
      /* Cidade */

      this.formFiltro.get("cidade").enable();
      this.formFiltro.get("classificacao").disable();
      this.formFiltro.get("cliente").disable();
      this.formFiltro.get("cnpj_cpf").disable();
      this.formFiltro.get("codigo").disable();
      this.formFiltro.get("nro_inicial_sem_compra").disable();
      this.formFiltro.get("nro_final_sem_compra").disable();
      this.formFiltro.get("nro_inicial_sem_visita").disable();
      this.formFiltro.get("nro_final_sem_visita").disable();
      this.formFiltro.get("valor_inicial_realizado_ano").disable();
      this.formFiltro.get("valor_final_realizado_ano").disable();
      this.formFiltro.get("valor_inicial_realizado_mes").disable();
      this.formFiltro.get("valor_final_realizado_mes").disable();
      this.formFiltro.get("segmento").disable();
    } else if (this.formFiltro.controls["filtro"].value == "1") {
      /* Classificação */

      this.formFiltro.get("cidade").disable();
      this.formFiltro.get("classificacao").enable();
      this.formFiltro.get("cliente").disable();
      this.formFiltro.get("cnpj_cpf").disable();
      this.formFiltro.get("codigo").disable();
      this.formFiltro.get("nro_inicial_sem_compra").disable();
      this.formFiltro.get("nro_final_sem_compra").disable();
      this.formFiltro.get("nro_inicial_sem_visita").disable();
      this.formFiltro.get("nro_final_sem_visita").disable();
      this.formFiltro.get("valor_inicial_realizado_ano").disable();
      this.formFiltro.get("valor_final_realizado_ano").disable();
      this.formFiltro.get("valor_inicial_realizado_mes").disable();
      this.formFiltro.get("valor_final_realizado_mes").disable();
      this.formFiltro.get("segmento").disable();
    } else if (this.formFiltro.controls["filtro"].value == "2") {
      /* Cliente */

      this.formFiltro.get("cidade").disable();
      this.formFiltro.get("classificacao").disable();
      this.formFiltro.get("cliente").enable();
      this.formFiltro.get("cnpj_cpf").disable();
      this.formFiltro.get("codigo").disable();
      this.formFiltro.get("nro_inicial_sem_compra").disable();
      this.formFiltro.get("nro_final_sem_compra").disable();
      this.formFiltro.get("nro_inicial_sem_visita").disable();
      this.formFiltro.get("nro_final_sem_visita").disable();
      this.formFiltro.get("valor_inicial_realizado_ano").disable();
      this.formFiltro.get("valor_final_realizado_ano").disable();
      this.formFiltro.get("valor_inicial_realizado_mes").disable();
      this.formFiltro.get("valor_final_realizado_mes").disable();
      this.formFiltro.get("segmento").disable();
    } else if (this.formFiltro.controls["filtro"].value == "3") {
      /* CNPJ/CPF */

      this.formFiltro.get("cidade").disable();
      this.formFiltro.get("classificacao").disable();
      this.formFiltro.get("cliente").disable();
      this.formFiltro.get("cnpj_cpf").enable();
      this.formFiltro.get("codigo").disable();
      this.formFiltro.get("nro_inicial_sem_compra").disable();
      this.formFiltro.get("nro_final_sem_compra").disable();
      this.formFiltro.get("nro_inicial_sem_visita").disable();
      this.formFiltro.get("nro_final_sem_visita").disable();
      this.formFiltro.get("valor_inicial_realizado_ano").disable();
      this.formFiltro.get("valor_final_realizado_ano").disable();
      this.formFiltro.get("valor_inicial_realizado_mes").disable();
      this.formFiltro.get("valor_final_realizado_mes").disable();
      this.formFiltro.get("segmento").disable();
    } else if (this.formFiltro.controls["filtro"].value == "4") {
      /* Código */

      this.formFiltro.get("cidade").disable();
      this.formFiltro.get("classificacao").disable();
      this.formFiltro.get("cliente").disable();
      this.formFiltro.get("cnpj_cpf").disable();
      this.formFiltro.get("codigo").enable();
      this.formFiltro.get("nro_inicial_sem_compra").disable();
      this.formFiltro.get("nro_final_sem_compra").disable();
      this.formFiltro.get("nro_inicial_sem_visita").disable();
      this.formFiltro.get("nro_final_sem_visita").disable();
      this.formFiltro.get("valor_inicial_realizado_ano").disable();
      this.formFiltro.get("valor_final_realizado_ano").disable();
      this.formFiltro.get("valor_inicial_realizado_mes").disable();
      this.formFiltro.get("valor_final_realizado_mes").disable();
      this.formFiltro.get("segmento").disable();
    } else if (this.formFiltro.controls["filtro"].value == "5") {
      /* Dias sem Compra */

      this.formFiltro.get("cidade").disable();
      this.formFiltro.get("classificacao").disable();
      this.formFiltro.get("cliente").disable();
      this.formFiltro.get("cnpj_cpf").disable();
      this.formFiltro.get("codigo").disable();
      this.formFiltro.get("nro_inicial_sem_compra").enable();
      this.formFiltro.get("nro_final_sem_compra").enable();
      this.formFiltro.get("nro_inicial_sem_visita").disable();
      this.formFiltro.get("nro_final_sem_visita").disable();
      this.formFiltro.get("valor_inicial_realizado_ano").disable();
      this.formFiltro.get("valor_final_realizado_ano").disable();
      this.formFiltro.get("valor_inicial_realizado_mes").disable();
      this.formFiltro.get("valor_final_realizado_mes").disable();
      this.formFiltro.get("segmento").disable();
    } else if (this.formFiltro.controls["filtro"].value == "6") {
      /* Dias sem Visita */

      this.formFiltro.get("cidade").disable();
      this.formFiltro.get("classificacao").disable();
      this.formFiltro.get("cliente").disable();
      this.formFiltro.get("cnpj_cpf").disable();
      this.formFiltro.get("codigo").disable();
      this.formFiltro.get("nro_inicial_sem_compra").disable();
      this.formFiltro.get("nro_final_sem_compra").disable();
      this.formFiltro.get("nro_inicial_sem_visita").enable();
      this.formFiltro.get("nro_final_sem_visita").enable();
      this.formFiltro.get("valor_inicial_realizado_ano").disable();
      this.formFiltro.get("valor_final_realizado_ano").disable();
      this.formFiltro.get("valor_inicial_realizado_mes").disable();
      this.formFiltro.get("valor_final_realizado_mes").disable();
      this.formFiltro.get("segmento").disable();
    } else if (this.formFiltro.controls["filtro"].value == "7") {
      /* Produto */

      this.formFiltro.get("cidade").disable();
      this.formFiltro.get("classificacao").disable();
      this.formFiltro.get("cliente").disable();
      this.formFiltro.get("cnpj_cpf").disable();
      this.formFiltro.get("codigo").disable();
      this.formFiltro.get("nro_inicial_sem_compra").disable();
      this.formFiltro.get("nro_final_sem_compra").disable();
      this.formFiltro.get("nro_inicial_sem_visita").disable();
      this.formFiltro.get("nro_final_sem_visita").disable();
      this.formFiltro.get("valor_inicial_realizado_ano").disable();
      this.formFiltro.get("valor_final_realizado_ano").disable();
      this.formFiltro.get("valor_inicial_realizado_mes").disable();
      this.formFiltro.get("valor_final_realizado_mes").disable();
      this.formFiltro.get("segmento").disable();
    } else if (this.formFiltro.controls["filtro"].value == "8") {
      /* Realizado Ano */

      this.formFiltro.get("cidade").disable();
      this.formFiltro.get("classificacao").disable();
      this.formFiltro.get("cliente").disable();
      this.formFiltro.get("cnpj_cpf").disable();
      this.formFiltro.get("codigo").disable();
      this.formFiltro.get("nro_inicial_sem_compra").disable();
      this.formFiltro.get("nro_final_sem_compra").disable();
      this.formFiltro.get("nro_inicial_sem_visita").disable();
      this.formFiltro.get("nro_final_sem_visita").disable();
      this.formFiltro.get("valor_inicial_realizado_ano").enable();
      this.formFiltro.get("valor_final_realizado_ano").enable();
      this.formFiltro.get("valor_inicial_realizado_mes").disable();
      this.formFiltro.get("valor_final_realizado_mes").disable();
      this.formFiltro.get("segmento").disable();
    } else if (this.formFiltro.controls["filtro"].value == "9") {
      /* Realizado Mês */

      this.formFiltro.get("cidade").disable();
      this.formFiltro.get("classificacao").disable();
      this.formFiltro.get("cliente").disable();
      this.formFiltro.get("cnpj_cpf").disable();
      this.formFiltro.get("codigo").disable();
      this.formFiltro.get("nro_inicial_sem_compra").disable();
      this.formFiltro.get("nro_final_sem_compra").disable();
      this.formFiltro.get("nro_inicial_sem_visita").disable();
      this.formFiltro.get("nro_final_sem_visita").disable();
      this.formFiltro.get("valor_inicial_realizado_ano").disable();
      this.formFiltro.get("valor_final_realizado_ano").disable();
      this.formFiltro.get("valor_inicial_realizado_mes").enable();
      this.formFiltro.get("valor_final_realizado_mes").enable();
      this.formFiltro.get("segmento").disable();
    } else if (this.formFiltro.controls["filtro"].value == "10") {
      /* Segmento */

      this.formFiltro.get("cidade").disable();
      this.formFiltro.get("classificacao").disable();
      this.formFiltro.get("cliente").disable();
      this.formFiltro.get("cnpj_cpf").disable();
      this.formFiltro.get("codigo").disable();
      this.formFiltro.get("nro_inicial_sem_compra").disable();
      this.formFiltro.get("nro_final_sem_compra").disable();
      this.formFiltro.get("nro_inicial_sem_visita").disable();
      this.formFiltro.get("nro_final_sem_visita").disable();
      this.formFiltro.get("valor_inicial_realizado_ano").disable();
      this.formFiltro.get("valor_final_realizado_ano").disable();
      this.formFiltro.get("valor_inicial_realizado_mes").disable();
      this.formFiltro.get("valor_final_realizado_mes").disable();
      this.formFiltro.get("segmento").enable();
    } else if (this.formFiltro.controls["filtro"].value == "11") {
      /* Tags */

      this.formFiltro.get("cidade").disable();
      this.formFiltro.get("classificacao").disable();
      this.formFiltro.get("cliente").disable();
      this.formFiltro.get("cnpj_cpf").disable();
      this.formFiltro.get("codigo").disable();
      this.formFiltro.get("nro_inicial_sem_compra").disable();
      this.formFiltro.get("nro_final_sem_compra").disable();
      this.formFiltro.get("nro_inicial_sem_visita").disable();
      this.formFiltro.get("nro_final_sem_visita").disable();
      this.formFiltro.get("valor_inicial_realizado_ano").disable();
      this.formFiltro.get("valor_final_realizado_ano").disable();
      this.formFiltro.get("valor_inicial_realizado_mes").disable();
      this.formFiltro.get("valor_final_realizado_mes").disable();
      this.formFiltro.get("segmento").disable();
    }

    this.tagFiltro = [];
  }

  verificarFiltro(): Promise<boolean> {
    return new Promise((resolver) => {
      if (localStorage.getItem("call_center_filtro") == null) {
        resolver(false);
        return;
      }

      let filtro: string = localStorage.getItem("call_center_filtro");

      const alterarFiltro = this.alterarFiltro(filtro, true);

      alterarFiltro.then(() => {
        if (localStorage.getItem("call_center_aba") != null) {
          this.tabSelecionada = localStorage.getItem("call_center_aba");

          if (this.tabSelecionada == "atencao" || this.tabSelecionada == "ligacoes") {
            this.tabSelecionada = "crm-ligacoes";
          }
        } else {
          this.tabSelecionada = "crm-ligacoes";
        }

        if (this.formFiltro.controls["filtro"].value == "0") {
          /* Cidade */

          if (localStorage.getItem("call_center_filtro_cidade") != null) {
            this.formFiltro.controls["cidade"].setValue(localStorage.getItem("call_center_filtro_cidade"));
          }
        } else if (this.formFiltro.controls["filtro"].value == "1") {
          /* Classificação */

          if (localStorage.getItem("call_center_filtro_classificacao") != null) {
            this.formFiltro.controls["classificacao"].setValue(localStorage.getItem("call_center_filtro_classificacao"));
          }
        } else if (this.formFiltro.controls["filtro"].value == "2") {
          /* Cliente */

          if (localStorage.getItem("call_center_filtro_cliente") != null) {
            this.formFiltro.controls["cliente"].setValue(localStorage.getItem("call_center_filtro_cliente"));
          }
        } else if (this.formFiltro.controls["filtro"].value == "3") {
          /* CNPJ/CPF */

          if (localStorage.getItem("call_center_filtro_cnpj_cpf") != null) {
            this.formFiltro.controls["cnpj_cpf"].setValue(localStorage.getItem("call_center_filtro_cnpj_cpf"));
          }
        } else if (this.formFiltro.controls["filtro"].value == "4") {
          /* Código */

          if (localStorage.getItem("call_center_filtro_codigo") != null) {
            this.formFiltro.controls["codigo"].setValue(localStorage.getItem("call_center_filtro_codigo"));
          }
        } else if (this.formFiltro.controls["filtro"].value == "5") {
          /* Dias sem Compra */

          if (localStorage.getItem("call_center_filtro_nro_inicial_sem_compra") != null) {
            this.formFiltro.controls["nro_inicial_sem_compra"].setValue(localStorage.getItem("call_center_filtro_nro_inicial_sem_compra"));
          }

          if (localStorage.getItem("call_center_filtro_nro_final_sem_compra") != null) {
            this.formFiltro.controls["nro_final_sem_compra"].setValue(localStorage.getItem("call_center_filtro_nro_final_sem_compra"));
          }
        } else if (this.formFiltro.controls["filtro"].value == "6") {
          /* Dias sem Visita */

          if (localStorage.getItem("call_center_filtro_nro_inicial_sem_visita") != null) {
            this.formFiltro.controls["nro_inicial_sem_visita"].setValue(localStorage.getItem("call_center_filtro_nro_inicial_sem_visita"));
          }

          if (localStorage.getItem("call_center_filtro_nro_final_sem_visita") != null) {
            this.formFiltro.controls["nro_final_sem_visita"].setValue(localStorage.getItem("call_center_filtro_nro_final_sem_visita"));
          }
        } else if (this.formFiltro.controls["filtro"].value == "7") {
          /* Produto */

          if (localStorage.getItem("call_center_filtro_produto") != null && localStorage.getItem("call_center_filtro_produto") != "") {
            let idProduto: number = parseInt(localStorage.getItem("call_center_filtro_produto"));

            let produtoSelecionado = this.produtos.find(produtos => produtos.id == idProduto);

            if (produtoSelecionado != null) {
              this.produtoSelecionado = produtoSelecionado;
            }
          }
        } else if (this.formFiltro.controls["filtro"].value == "8") {
          /* Realizado Ano */

          if (localStorage.getItem("call_center_filtro_valor_inicial_realizado_ano") != null) {
            this.formFiltro.controls["valor_inicial_realizado_ano"].setValue(localStorage.getItem("call_center_filtro_valor_inicial_realizado_ano"));
          }

          if (localStorage.getItem("call_center_filtro_valor_final_realizado_ano") != null) {
            this.formFiltro.controls["valor_final_realizado_ano"].setValue(localStorage.getItem("call_center_filtro_valor_final_realizado_ano"));
          }
        } else if (this.formFiltro.controls["filtro"].value == "9") {
          /* Realizado Mês */

          if (localStorage.getItem("call_center_filtro_valor_inicial_realizado_mes") != null) {
            this.formFiltro.controls["valor_inicial_realizado_mes"].setValue(localStorage.getItem("call_center_filtro_valor_inicial_realizado_mes"));
          }

          if (localStorage.getItem("call_center_filtro_valor_final_realizado_mes") != null) {
            this.formFiltro.controls["valor_final_realizado_mes"].setValue(localStorage.getItem("call_center_filtro_valor_final_realizado_mes"));
          }
        } else if (this.formFiltro.controls["filtro"].value == "10") {
          /* Segmento */

          if (localStorage.getItem("call_center_filtro_segmento") != null) {
            this.formFiltro.controls["segmento"].setValue(localStorage.getItem("call_center_filtro_segmento"));
          }
        } else if (this.formFiltro.controls["filtro"].value == "11") {
          /* Tags */

          if (localStorage.getItem("call_center_filtro_tags") != null) {
            this.tagFiltro = JSON.parse(localStorage.getItem("call_center_filtro_tags"));
          }
        }

        if (localStorage.getItem("call_center_filtro_vendedor") != "") {
          this.formFiltro.controls["vendedor"].setValue(localStorage.getItem("call_center_filtro_vendedor"));
        }

        this.filtrar();
        resolver(true);
      });
    });
  }

  /* Filtro (Produtos) */

  alterarFiltroProduto(filtro_selecionado: number) {
    this.reiniciarDadosProduto();

    let filtroAtual: string = this.formFiltroProduto.controls["filtro"].value;

    this.formFiltroProduto.reset();

    if (filtro_selecionado == null) {
      this.formFiltroProduto.controls["filtro"].setValue(filtroAtual);
    } else {
      this.formFiltroProduto.controls["filtro"].setValue(filtro_selecionado);
    }

    this.organizarFiltroProduto();

    this.enviadoProduto = false;
    this.filtrandoProduto = false;
  }

  filtrarProduto() {
    this.enviadoProduto = true;

    if (this.formFiltroProduto.invalid) {
      return;
    }

    this.reiniciarDadosProduto();

    if (this.formFiltroProduto.controls["filtro"].value == "0") {
      /* Código */

      if (this.formFiltroProduto.controls["codigo"].value != "" && this.formFiltroProduto.controls["codigo"].value != null) {
        this.produtos = this.produtos.filter(produto => {
          if (produto.codigo == null) {
            return false;
          } else {
            return (produto.codigo.toLowerCase().indexOf(this.formFiltroProduto.controls["codigo"].value.trim().toLowerCase()) !== -1);
          }
        });
      }
    } else if (this.formFiltroProduto.controls["filtro"].value == "1") {
      /* Descrição */

      if (this.formFiltroProduto.controls["descricao"].value != "" && this.formFiltroProduto.controls["descricao"].value != null) {
        this.produtos = this.produtos.filter(produto => {
          if (produto.name == null) {
            return false;
          } else {
            return (produto.name.toLowerCase().indexOf(this.formFiltroProduto.controls["descricao"].value.trim().toLowerCase()) !== -1);
          }
        });
      }
    } else if (this.formFiltroProduto.controls["filtro"].value == "2") {
      /* Marca */

      if (this.formFiltroProduto.controls["marca"].value != "" && this.formFiltroProduto.controls["marca"].value != null) {
        this.produtos = this.produtos.filter(produto => {
          if (produto.grupo_estoque == null) {
            return false;
          } else {
            return (produto.grupo_estoque.toLowerCase().indexOf(this.formFiltroProduto.controls["marca"].value.trim().toLowerCase()) !== -1);
          }
        });
      }
    }

    this.filtrandoProduto = true;
  }

  organizarFiltroProduto() {
    if (this.formFiltroProduto.controls["filtro"].value == "0") {
      /* Código */

      this.formFiltroProduto.get("codigo").enable();
      this.formFiltroProduto.get("descricao").disable();
      this.formFiltroProduto.get("marca").disable();
    } else if (this.formFiltroProduto.controls["filtro"].value == "1") {
      /* Descrição */

      this.formFiltroProduto.get("codigo").disable();
      this.formFiltroProduto.get("descricao").enable();
      this.formFiltroProduto.get("marca").disable();
    } else if (this.formFiltroProduto.controls["filtro"].value == "2") {
      /* Marca */

      this.formFiltroProduto.get("codigo").disable();
      this.formFiltroProduto.get("descricao").disable();
      this.formFiltroProduto.get("marca").enable();
    }
  }

  reiniciarDadosProduto() {
    this.produtos = JSON.parse(JSON.stringify(this.produtosOriginal));
  }

  selecionarProdutoFiltrado(id_produto: number) {
    let produtoSelecionado = this.produtos.find(produtos => produtos.id == id_produto);

    if (produtoSelecionado != null) {
      this.produtoSelecionado = produtoSelecionado;

      if (this.produtoSelecionado.qtde_lote == 0) {
        this.produtoSelecionado.valor = this.produtoSelecionado.price;
      } else {
        this.produtoSelecionado.valor = null;
      }

      this.alterarFiltroProduto(null);

      this.produtoEmBranco = false;
      this.produtoInvalido = false;
      this.filtrandoProduto = false;

      this.filtrar();
    }
  }

  /* Modal */

  modalAnaliseSintetica(content: any) {
    /* Pedidos (Totalizador) */

    /* Este Mês */

    this.pedidoTotalizadorService.getEsteMesByUsuario().subscribe(
      pedidoTotalizadorEsteMes => this.valorVendasMes = pedidoTotalizadorEsteMes,
      error => { console.log("Erro: " + error) },
      () => {
        /* Hoje */

        this.pedidoTotalizadorService.getHojeByUsuario().subscribe(
          pedidoTotalizadorHoje => this.valorVendasDia = pedidoTotalizadorHoje,
          error => { console.log("Erro: " + error) },
          () => {
            this.calcularDadosAnaliseSintetica();

            this.modalService.open(content, {
              ariaLabelledBy: "titulo-analise-sintetica",
              size: "xl",
              backdrop: "static"
            });
          }
        );
      }
    );
  }

  continuarNovaLigacao(id_cliente: number, ligacao_selecionada: number) {
    if (ligacao_selecionada != null) {
      this.router.navigate(["/call-center-ligacao/" + ligacao_selecionada]);
    } else {
      let chamadas_automaticas: boolean = (localStorage.getItem("chamadas_automaticas") == "true");

      if (chamadas_automaticas) {
        this.callCenterDiscadorService.chamadasReiniciarTempo();
      }

      if (id_cliente != null) {
        this.router.navigate(["/call-center-nova-ligacao"], {
          queryParams: {
            cliente: id_cliente
          }
        });
      } else {
        this.router.navigate(["/call-center-nova-ligacao/"]);
      }
    }
  }

  modalLigacaoMensagem(content: any, mensagem: string) {
    this.ligacaoAnaliticaMensagem = mensagem;

    this.modalService.open(content, {
      ariaLabelledBy: "titulo-ligacao-mensagem",
      size: "lg",
      backdrop: "static"
    });
  }

  modalTagsClientes(content: any, origem: string, id_cliente: number) {
    this.tagCliente = [];

    this.tagClienteIdSelecionado = 0;
    this.tagClienteNomeSelecionado = "";

    switch (origem) {
      case "ligacoes":
        let ligacaoSelecionada = this.ligacoesAnaliticas.find(ligacaoAnalitica => ligacaoAnalitica.client_id == id_cliente);

        if (ligacaoSelecionada != null) {
          ligacaoSelecionada.cliente_tags.forEach((item) => {
            this.tagCliente.push({
              tagLabel: item.descricao,
              tagValue: item.descricao
            });
          });

          this.tagClienteIdSelecionado = ligacaoSelecionada.client_id;
          this.tagClienteNomeSelecionado = ligacaoSelecionada.name;
        }

        break;
      case "oportunidades":
        let oportunidadeSelecionada = this.oportunidades.find(oportunidade => oportunidade.client_id_app == id_cliente);

        if (oportunidadeSelecionada != null) {
          oportunidadeSelecionada.cliente_tags.forEach((item) => {
            this.tagCliente.push({
              tagLabel: item.descricao,
              tagValue: item.descricao
            });
          });

          this.tagClienteIdSelecionado = oportunidadeSelecionada.client_id_app;
          this.tagClienteNomeSelecionado = oportunidadeSelecionada.name;
        }

        break;
      case "crm-ligacoes":
        let crmLigacaoSelecionada = this.crmLigacoes.find(ligacao => ligacao.client_id == id_cliente);

        if (crmLigacaoSelecionada != null) {
          this.tagClienteIdSelecionado = crmLigacaoSelecionada.client_id;
          this.tagClienteNomeSelecionado = crmLigacaoSelecionada.name;
        }

        break;
      default:

    }

    if (this.tagClienteIdSelecionado != 0) {
      this.modalService.open(content, {
        ariaLabelledBy: "titulo-tags-clientes",
        size: "lg",
        backdrop: "static"
      }).result.then((acao) => {
        if (acao == "Salvar") {
          let tags: string[] = [];

          this.tagCliente.forEach((item) => {
            tags.push(item.tagValue);
          });

          let adicionarTag: boolean = false;

          this.clienteService.addTag(this.tagClienteIdSelecionado, tags).subscribe(
            adicionarTags => adicionarTag = adicionarTags,
            error => { console.log("Erro: " + error) },
            () => {
              if (adicionarTag) {
                /* Atualiza Dados */

                switch (origem) {
                  case "ligacoes":
                    let ligacaoAnaliticaSelecionada: CallCenterLigacaoAnalitica = this.ligacoesAnaliticas.find(ligacaoAnalitica => ligacaoAnalitica.client_id == id_cliente);

                    if (ligacaoAnaliticaSelecionada != null) {
                      ligacaoAnaliticaSelecionada.cliente_tags = [];

                      tags.forEach((item) => {
                        let tag = new ClienteTag();

                        tag.client_id_app = id_cliente;
                        tag.descricao = item;

                        ligacaoAnaliticaSelecionada.cliente_tags.push(tag);
                      });

                      let ligacaoAnaliticaOriginalSelecionada = this.ligacoesAnaliticasOriginal.find(ligacaoAnaliticaOriginal => ligacaoAnaliticaOriginal.id == ligacaoAnaliticaSelecionada.id);

                      if (ligacaoAnaliticaOriginalSelecionada != null) {
                        ligacaoAnaliticaOriginalSelecionada.cliente_tags = ligacaoAnaliticaSelecionada.cliente_tags;
                      }
                    }

                    break;
                  case "oportunidades":
                    let oportunidadeSelecionada: CallCenterOportunidade = this.oportunidades.find(oportunidade => oportunidade.client_id_app == id_cliente);

                    if (oportunidadeSelecionada != null) {
                      oportunidadeSelecionada.cliente_tags = [];

                      tags.forEach((item) => {
                        let tag = new ClienteTag();

                        tag.client_id_app = id_cliente;
                        tag.descricao = item;

                        oportunidadeSelecionada.cliente_tags.push(tag);
                      });
                    }

                    break;
                  default:
                }

                this.toastr.success("", "Tag(s) salva(s) com sucesso!");
              }
            }
          );
        }
      }, () => {

      });
    }
  }

  /* Ordernar (Ligações) */

  ordernarLigacoes(opcao_selecionada: string) {
    this.ordernarLigacoesSelecionado = opcao_selecionada;

    switch (this.ordernarLigacoesOrdemSelecionado) {
      case "0":
        /* Crescente */

        this.ligacoesAnaliticasOriginal.sort((a, b) => {
          const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

          return compare(a[this.ordernarLigacoesSelecionado], b[this.ordernarLigacoesSelecionado]);
        });

        break;
      case "1":
        /* Decrescente */

        this.ligacoesAnaliticasOriginal.sort((a, b) => {
          const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

          return compare(a[this.ordernarLigacoesSelecionado], b[this.ordernarLigacoesSelecionado]) * -1; /* Decrescente */
        });

        break;
      default:

    }

    this.ligacoesAnaliticas = JSON.parse(JSON.stringify(this.ligacoesAnaliticasOriginal));
  }

  ordernarLigacoesOrdem(opcao_selecionada: string) {
    this.ordernarLigacoesOrdemSelecionado = opcao_selecionada;

    this.ordernarLigacoes(this.ordernarLigacoesSelecionado);
  }

  ordernarLigacoesOrganizarOpcoes() {
    this.ordernarLigacoesOpcoes.sort((a, b) => {
      const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

      return compare(a["texto"], b["texto"]);
    });
  }

  /* Ordernar (Oportunidades) */

  ordernarOportunidades(opcao_selecionada: string) {
    let oportunidadesAnterior = this.oportunidades;

    this.ordernarOportunidadesSelecionado = opcao_selecionada;

    switch (this.ordernarOportunidadesOrdemSelecionado) {
      case "0":
        /* Crescente */

        oportunidadesAnterior.sort((a, b) => {
          const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

          return compare(a[this.ordernarOportunidadesSelecionado], b[this.ordernarOportunidadesSelecionado]);
        });

        break;
      case "1":
        /* Decrescente */

        oportunidadesAnterior.sort((a, b) => {
          const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

          return compare(a[this.ordernarOportunidadesSelecionado], b[this.ordernarOportunidadesSelecionado]) * -1; /* Decrescente */
        });

        break;
      default:

    }

    this.oportunidades = JSON.parse(JSON.stringify(oportunidadesAnterior));
  }

  ordernarOportunidadesOrdem(opcao_selecionada: string) {
    this.ordernarOportunidadesOrdemSelecionado = opcao_selecionada;

    this.ordernarOportunidades(this.ordernarOportunidadesSelecionado);
  }

  ordernarOportunidadesOrganizarOpcoes() {
    this.ordernarOportunidadesOpcoes.sort((a, b) => {
      const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

      return compare(a["texto"], b["texto"]);
    });
  }
}
